<mat-accordion displayMode="flat" togglePosition="before" class="mat-list-custom">
  <div class="sidecontent-option-container" [ngSwitch]="displayedContent">
    <div class="scroll-container">
      <!-- done -->
      <ng-container *ngSwitchCase="widgetTypes.plainText">
        <form [formGroup]="textGroup">
          <ng-container [ngTemplateOutlet]="widgetId"></ng-container>
          <mat-divider></mat-divider>
          <mat-expansion-panel [expanded]="widgetChange" (closed)="widgetChange = false">
            <mat-expansion-panel-header>
              <mat-panel-title> Text Properties </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="ps-4 mat-form-field-container">
              <mat-form-field appearance="outline">
                <mat-label>Text</mat-label>
                <input matInput type="text" formControlName="label" />
                <mat-error class="text-danger" *ngIf="textGroup.get('label')?.value?.trim().length == 0">Enter value to the label</mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline" *ngIf="selectedPageData.pageType !== pageTypes.dataListView">
                  <mat-label>Position</mat-label>
                  <mat-select  searchable [isObjectsList]="false"  formControlName="align">
                    <mat-option value="left">Left</mat-option>
                    <mat-option value="center">Center</mat-option>
                    <mat-option value="right">Right</mat-option>
                  </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Top Margin</mat-label>
                <input matInput type="number" formControlName="marginTop" (keydown.enter)="$event.preventDefault()"/>
              </mat-form-field>

              <mat-accordion displayMode="flat" togglePosition="before">
                <mat-expansion-panel>
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      Link
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <mat-form-field class="w-100" appearance="outline">
                    <mat-label>Entity</mat-label>
                    <mat-select (click)="isEntityClicked()"
                      (selectionChange)="onEntitySelected($event)" formControlName="linkEntityId" disableRipple searchable [isObjectsList]="true" [displayKey]="'entity_name'">
                      <mat-option *ngFor="let option of entityList" [value]="option.entity_id">
                        {{ option.entity_name }}</mat-option>
                      </mat-select>
                      <mat-hint class="error-message small" *ngIf="isEntityTouched && entityList.length==0">Entity not found. Please create an entity first.</mat-hint>
                      <mat-error class="small" *ngIf="textGroup.get('linkEntityId')?.hasError('required') &&  entityList.length>0 ">Please select an option from the dropdown</mat-error>
                      <mat-error class="small" *ngIf="textGroup.get('linkEntityId')?.hasError('required') &&  entityList.length==0">Entity not found. Please create an entity first.</mat-error>
                      <button mat-icon-button matIconSuffix color="warn" *ngIf="textGroup?.get('linkEntityId')?.value" (click)="clearEntitySeletion(textGroup)"><mat-icon>close</mat-icon></button>
                  </mat-form-field>
    
                  <mat-form-field class="w-100" appearance="outline"  *ngIf="textGroup?.get('linkEntityId')?.value">
                    <mat-label>Select Widget</mat-label>
                    <mat-select multiple  formControlName="linkWidgetId" disableRipple searchable [isObjectsList]="true" [displayKey]="'widgetLabel'">
                      <mat-option *ngFor="let widget of filterWidgetList" [value]="widget.widgetId">
                        {{ widget.widgetLabel }}</mat-option>
                      </mat-select>
    
                  </mat-form-field>
                </mat-expansion-panel>
              </mat-accordion>
              <div class="theming-color-items mt-2">
                <div class="color-item">
                  <div class="content">
                    <div class="label">Text Color</div>
                    <div class="value">{{ textGroup.get('textColor')?.value }}</div>
                  </div>
                  <div [style.background-color]="textGroup.get('textColor')?.value" mat-ripple class="color-thumb">
                    <input type="color" formControlName="textColor" />
                  </div>
                </div>
                <ng-container [ngTemplateOutlet]="fontIconTemplate"
                  [ngTemplateOutletContext]="{ formGroup: textGroup }"></ng-container>
              </div>
              @if(this.enableUpdate) {
                <button mat-stroked-button class="w-100 mt-3" color="primary" (click)="updateWidgetValues()">Update
                  component</button>
              }
            </div>
          </mat-expansion-panel>
          <ng-container [ngTemplateOutlet]="actionsTemplate" *ngIf="widgetActionsandValidations[selectedWidgetMetaData.widgetType].action.length > 0 && selectedPageData?.pageType !== pageTypes.dataListView"></ng-container>
        </form>
      </ng-container>

      <ng-container *ngSwitchCase="widgetTypes.filePicker">
        <form [formGroup]="filePickerGroup">
          <ng-container [ngTemplateOutlet]="widgetId"></ng-container>
            <mat-divider></mat-divider>
            <mat-expansion-panel [expanded]="widgetChange" (closed)="widgetChange = false">
              <mat-expansion-panel-header>
                <mat-panel-title> File Properties</mat-panel-title>
              </mat-expansion-panel-header>
              <div class=" ps-4 mat-form-field-container">

                <mat-form-field appearance="outline">
                  <mat-label>Display Type</mat-label>
                  <mat-select formControlName="matUiType">
                    <mat-option value="filled">Filled</mat-option>
                    <mat-option value="outlined">Outlined</mat-option>
                  </mat-select>
                </mat-form-field>
                
                <mat-form-field appearance="outline">
                  <mat-label>Label</mat-label>
                  <input matInput type="text" formControlName="label" />
                  <mat-error class="text-danger" *ngIf="filePickerGroup.get('label')?.value?.trim().length == 0"> Enter value to the label</mat-error>
                </mat-form-field>



                <mat-form-field appearance="outline">
                  <mat-label>Top Margin</mat-label>
                  <input matInput type="number" formControlName="marginTop" (keydown.enter)="$event.preventDefault()"/>
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label>Files types</mat-label>
                  <mat-select  searchable [isObjectsList]="true" [displayKey]="'key'" formControlName="fileType" placeholder="Select File Types" multiple>
                    <mat-option *ngFor="let file of fileTypes" [value]="file.value">{{file.key}}</mat-option>
                  </mat-select>
                  <mat-error class="error-message" *ngIf="filePickerGroup.get('fileType')?.hasError('required')">Please select file format</mat-error>
                </mat-form-field>     

                <mat-form-field appearance="outline">
                  <mat-label>Max Size</mat-label>
                  <input matInput type="number" formControlName="maxSize" placeholder="Numeric value in MB"  (wheel)="preventScroll($event)"/>
                  <mat-error class="error-message" *ngIf="filePickerGroup.get('maxSize')?.hasError('min')">Size cannot be less than 0</mat-error>
                  <mat-error class="error-message" *ngIf="filePickerGroup.get('maxSize')?.hasError('required')">Please enter max size</mat-error>
               </mat-form-field>

               <div *ngFor="let toggle of fileToggles" class="outline toggle-container custom-toggle-container">
                <mat-slide-toggle [formControlName]="toggle.formControlName">
                  <span class="font-add">{{ toggle.label }}</span>
                </mat-slide-toggle>
              </div>

                <div class="theming-color-items">
                  <div class="color-item">
                    <div class="content">
                      <div class="label">Text Color</div>
                      <div class="value">{{ filePickerGroup.get('textColor')?.value }}</div>
                    </div>
                    <div [style.background-color]="filePickerGroup.get('textColor')?.value" mat-ripple
                      class="color-thumb">
                      <input type="color" formControlName="textColor" />
                    </div>
                  </div>
                </div>
                @if(this.enableUpdate) {
                <button mat-stroked-button class="w-100 mt-3" color="primary" (click)="updateWidgetValues()">Update
                  component</button>
                }
              </div>
            </mat-expansion-panel>
            <ng-container [ngTemplateOutlet]="validationsTemplate" *ngIf="widgetActionsandValidations[selectedWidgetMetaData.widgetType].validation.length > 0"></ng-container>
        </form>
      </ng-container>

      <ng-container *ngSwitchCase="widgetTypes.image">
        <form [formGroup]="imagePickerGroup">
          <ng-container [ngTemplateOutlet]="widgetId"></ng-container>
          <mat-divider></mat-divider>
          <mat-expansion-panel [expanded]="widgetChange" (closed)="widgetChange = false">
            <mat-expansion-panel-header>
              <mat-panel-title> Image/Video Properties</mat-panel-title>
            </mat-expansion-panel-header>
            <div class="ps-4 mat-form-field-container">

              <mat-form-field appearance="outline">
                <mat-label>Display Type</mat-label>
                <mat-select formControlName="matUiType">
                  <mat-option value="filled">Filled</mat-option>
                  <mat-option value="outlined">Outlined</mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Label</mat-label>
                <input matInput type="text" formControlName="label" />
                <mat-error class="text-danger" *ngIf="imagePickerGroup.get('label')?.value?.trim().length == 0">Enter value to the label</mat-error>
              </mat-form-field>

              
              <mat-form-field appearance="outline">
                <mat-label>Top Margin</mat-label>
                <input matInput type="number" formControlName="marginTop" (keydown.enter)="$event.preventDefault()"/>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Upload Type</mat-label>
                <mat-select formControlName="uploadType"  searchable [isObjectsList]="false">
                  <mat-option value="image">Image Capture</mat-option>
                  <mat-option value="video">Video Capture</mat-option>
                  <mat-option value="document">Document Capture</mat-option>
                </mat-select>
                <mat-error class="error-message" *ngIf="imagePickerGroup.get('uploadType')?.hasError('required')">Please
                  select upload type</mat-error>
              </mat-form-field>

              <!-- Image specific properties -->
              <ng-container *ngIf="imagePickerGroup.get('uploadType')?.value === 'image'">
                <mat-form-field appearance="outline">
                  <mat-label>Allowed Image Types</mat-label>
                  <mat-select formControlName="allowedTypes" placeholder="Select Image Types" multiple  searchable [isObjectsList]="true" [displayKey]="'key'">
                    <mat-option *ngFor="let image of imageFormats" [value]="image.value">{{image.key}}</mat-option>
                  </mat-select>
                  <mat-error class="error-message" *ngIf="imagePickerGroup.get('allowedTypes')?.hasError('required')">Please
                    select image format</mat-error>
                </mat-form-field>
              
                <mat-form-field appearance="outline" class="mt-2">
                  <mat-label>Max Image Size</mat-label>
                  <input matInput type="number" formControlName="maxSize" placeholder="Numeric value in MB"
                    (wheel)="preventScroll($event)" />
                  <mat-error class="error-message" *ngIf="imagePickerGroup.get('maxSize')?.hasError('min')">Size cannot be less
                    than 0</mat-error>
                </mat-form-field>
                
                  <div *ngFor="let toggle of imageToggles" class="outline toggle-container custom-toggle-container">
                    <mat-slide-toggle [formControlName]="toggle.formControlName">
                      <span class="font-add">{{ toggle.label }}</span>
                    </mat-slide-toggle>
                  </div>

                 
                  <ng-container [ngTemplateOutlet]="greet"  *ngIf="imagePickerGroup.get('GeoReference')?.value == true"></ng-container>
                  <ng-template #greet>
                    <div class="outline toggle-container custom-toggle-container">
                      <mat-slide-toggle formControlName="baringToggle">
                        <span class="font-add">Baring</span>
                      </mat-slide-toggle>
                    </div>
                    <mat-form-field appearance="outline" class="mt-2 w-100">
                      <mat-label>GPS Accuracy</mat-label>
                       <mat-select formControlName="gpsAccuracy"  placeholder="Select GPS Accuracy"  searchable [isObjectsList]="true" [displayKey]="'range'">
                        <mat-option *ngFor="let value of accuracies" [value]="value.accuracy">{{value.range + ' mtrs'}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </ng-template>
              </ng-container>

              <ng-container *ngIf="imagePickerGroup.get('uploadType')?.value === 'video'">
                <!-- Video-specific properties -->
                <mat-form-field appearance="outline">
                  <mat-label>Allowed Video Types</mat-label>
                  <mat-select formControlName="allowedTypes" placeholder="Select Video Types" multiple  searchable [isObjectsList]="true" [displayKey]="'key'">
                    <mat-option *ngFor="let video of videoFormats" [value]="video.value">{{video.key}}</mat-option>
                  </mat-select>
                  <mat-error class="error-message" *ngIf="imagePickerGroup.get('allowedTypes')?.hasError('required')">Please
                    select video format</mat-error>
                </mat-form-field>
              
                <mat-form-field appearance="outline" class="mt-2">
                  <mat-label>Max Video Size</mat-label>
                  <input matInput type="number" formControlName="maxSize" placeholder="Numeric value (e.g., MB)"
                    (wheel)="preventScroll($event)" />
                  <mat-error class="error-message" *ngIf="imagePickerGroup.get('maxSize')?.hasError('min')">Size cannot be less
                    than 0</mat-error>
                </mat-form-field>
              
                  <div *ngFor="let toggle of videoToggles" class="outline toggle-container custom-toggle-container">
                    <mat-slide-toggle [formControlName]="toggle.formControlName">
                      <span class="font-add">{{ toggle.label }}</span>
                    </mat-slide-toggle>
                  </div>

                  <ng-container [ngTemplateOutlet]="greet"  *ngIf="imagePickerGroup.get('GeoReference')?.value == true"></ng-container>
                  <ng-template #greet>
                    <div class="outline toggle-container custom-toggle-container">
                      <mat-slide-toggle formControlName="baringToggle">
                        <span class="font-add">Baring</span>
                      </mat-slide-toggle>
                    </div>
                    <mat-form-field appearance="outline" class="mt-2 w-100">
                      <mat-label>GPS Accuracy</mat-label>
                      <mat-select formControlName="gpsAccuracy"  placeholder="Select GPS Accuracy" searchable [isObjectsList]="true" [displayKey]="'range'">
                        <mat-option *ngFor="let value of accuracies" [value]="value.accuracy">{{value.range + ' mtrs'}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </ng-template>
                
              </ng-container>

              <div class="theming-color-items">
                <div class="color-item">
                  <div class="content">
                    <div class="label">Text/Icon Color</div>
                    <div class="value">{{ imagePickerGroup.get('textColor')?.value }}</div>
                  </div>
                  <div [style.background-color]="imagePickerGroup.get('textColor')?.value" mat-ripple
                    class="color-thumb">
                    <input type="color" formControlName="textColor" />
                  </div>
                </div>
              </div>
              @if(this.enableUpdate) {
              <button mat-stroked-button class="w-100 mt-3" color="primary" (click)="updateWidgetValues()">Update
                component</button>
              }
            </div>
          </mat-expansion-panel>
          <ng-container [ngTemplateOutlet]="validationsTemplate" *ngIf="widgetActionsandValidations[selectedWidgetMetaData.widgetType].validation.length > 0"></ng-container>
        </form>
      </ng-container>

      <!-- done -->
      <ng-container *ngSwitchCase="widgetTypes.button">
        <form [formGroup]="buttonGroup">
          <ng-container [ngTemplateOutlet]="widgetId"></ng-container>
          <mat-divider></mat-divider>

          <mat-expansion-panel [expanded]="widgetChange" (closed)="widgetChange = false">
            <mat-expansion-panel-header>
              <mat-panel-title> Button Styling </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="ps-4 mat-form-field-container">
              <mat-form-field appearance="outline">
                <mat-label>Display Type</mat-label>
                <mat-select formControlName="matUiType">
                  <mat-option value="filled">Filled</mat-option>
                  <mat-option value="outlined">Outlined</mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>Text</mat-label>
                <input matInput type="text" formControlName="label" (input)="updateWidgetLabel()" (keydown.enter)="$event.preventDefault()"/>
                <mat-error class="text-danger" *ngIf="buttonGroup.get('label')?.value?.trim().length == 0">Enter value to the label</mat-error>
              </mat-form-field>


              <mat-form-field appearance="outline">
                <mat-label>Top Margin</mat-label>
                <input matInput type="number" formControlName="marginTop" (keydown.enter)="$event.preventDefault()" />
              </mat-form-field>

              <div class="theming-color-items">
                <div class="color-item">
                  <div class="content">
                    <div class="label"> {{buttonGroup.get('matUiType')?.value == 'filled' ? 'Button Color' : 'Outline Color'}}</div>
                    <div class="value">{{ buttonGroup.get('bgColor')?.value }}</div>
                  </div>
                  <div [style.background-color]="buttonGroup.get('bgColor')?.value" mat-ripple class="color-thumb">
                    <input type="color" formControlName="bgColor" />
                  </div>
                </div>

                <div class="color-item">
                  <div class="content">
                    <div class="label">Text Color</div>
                    <div class="value">{{ buttonGroup.get('textColor')?.value }}</div>
                  </div>
                  <div [style.background-color]="
                      buttonGroup.get('textColor')?.value
                    " mat-ripple class="color-thumb">
                    <input type="color" formControlName="textColor" />
                  </div>
                </div>
              </div>
              <ng-container [ngTemplateOutlet]="fontIconTemplate"
              [ngTemplateOutletContext]="{ formGroup: buttonGroup }"></ng-container>
              @if(this.enableUpdate) {
              <button mat-stroked-button class="w-100 mt-3" color="primary" (click)="updateWidgetValues()">Update
                component</button>
              }
            </div>
          </mat-expansion-panel>
          <ng-container [ngTemplateOutlet]="actionsTemplate" *ngIf="widgetActionsandValidations[selectedWidgetMetaData.widgetType].action.length > 0"></ng-container>
          <ng-container [ngTemplateOutlet]="lineItemPreviewConfig" *ngIf="selectedPageData.pageType === pageTypes.dataListView && hasLineItemAction(this.selectedWidgetMetaData.widgetConfig)"></ng-container>
        </form>
      </ng-container>

      <!-- done -->
      <ng-container *ngSwitchCase="widgetTypes.textbox">
        <form [formGroup]="textFieldGroup">
          <ng-container [ngTemplateOutlet]="widgetId"></ng-container>
          <mat-divider></mat-divider>

          <mat-expansion-panel [expanded]="widgetChange" (closed)="widgetChange = false">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div class="panal" style="display: flex;">
                  <div class="panal-title"> Input Properties</div>
                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>

           
            <div class="ps-4 mat-form-field-container">

              <mat-form-field  appearance="outline">
                <mat-label>Display Type</mat-label>
                <mat-select formControlName="matUiType">
                  <mat-option value="filled">Filled</mat-option>
                  <mat-option value="outlined">Outlined</mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Label</mat-label>
                <input matInput type="text" formControlName="label" />
                <mat-error class="text-danger" *ngIf="textFieldGroup.get('label')?.value?.trim().length == 0">Enter value to the label</mat-error>
              </mat-form-field>


              <mat-form-field appearance="outline">
                <mat-label> Data Type</mat-label>
                <mat-select formControlName="type">
                  <mat-option value="number">Number</mat-option>
                  <mat-option value="text">Text</mat-option>
                  <mat-option value="password">Password</mat-option>

                </mat-select>
              </mat-form-field>

             <div class="toggle-container custom-toggle-container " *ngIf="textFieldGroup.get('type')?.value == 'number'">
                    <mat-slide-toggle class="w-100" formControlName="allowNegative" >Allow negative values</mat-slide-toggle>       
                  </div>
              <mat-form-field appearance="outline">
                <mat-label>Placeholder</mat-label>
                <input matInput type="text" formControlName="placeholder" (keydown.enter)="$event.preventDefault()"/>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Top Margin</mat-label>
                <input matInput type="number"formControlName="marginTop" (keydown.enter)="$event.preventDefault()"/>
              </mat-form-field>

              <div class="theming-color-items">
                <div class="color-item">
                  <div class="content">
                    <div class="label">Text Color</div>
                    <div class="value">{{textFieldGroup.get('textColor')?.value}}</div>
                  </div>
                  <div [style.background-color]="textFieldGroup.get('textColor')?.value" mat-ripple class="color-thumb">
                    <input type="color" formControlName="textColor" />
                  </div>
                </div>
              </div>
              @if(this.enableUpdate) {
              <button mat-stroked-button class="w-100 mt-3" color="primary" (click)="updateWidgetValues()">Update
                component</button>
              }
            </div>
          </mat-expansion-panel>
          <ng-container [ngTemplateOutlet]="actionsTemplate" *ngIf="widgetActionsandValidations[selectedWidgetMetaData.widgetType].action.length > 0 "></ng-container>
          <ng-container [ngTemplateOutlet]="validationsTemplate" *ngIf="widgetActionsandValidations[selectedWidgetMetaData.widgetType].validation.length > 0"></ng-container>
        </form>
      </ng-container>

      <!-- need inputs -->
      <ng-container *ngSwitchCase="widgetTypes.singleselectcheckbox">
        <form [formGroup]="checkBoxGroup">
          <ng-container [ngTemplateOutlet]="widgetId"></ng-container>
          <mat-divider></mat-divider>

          <mat-expansion-panel [expanded]="widgetChange" (closed)="widgetChange = false">
            <mat-expansion-panel-header>
              <mat-panel-title> Input Properties </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="ps-4 mat-form-field-container">
              <mat-form-field appearance="outline">
                <mat-label>Label</mat-label>
                <input matInput type="text" formControlName="label" />
                <mat-error class="text-danger" *ngIf="checkBoxGroup.get('label')?.value?.trim().length == 0"> Enter value to the label</mat-error>
              </mat-form-field>


              <mat-form-field appearance="outline">
                <mat-label>Top Margin</mat-label>
                <input matInput type="number"  formControlName="marginTop" (keydown.enter)="$event.preventDefault()"/>
              </mat-form-field>

              <div class="theming-color-items">
                <div class="color-item">
                  <div class="content">
                    <div class="label">Text Color</div>
                    <div class="value">{{ checkBoxGroup.get('textColor')?.value }}</div>
                  </div>
                  <div [style.background-color]="checkBoxGroup.get('textColor')?.value" mat-ripple class="color-thumb">
                    <input type="color" formControlName="textColor" />
                  </div>
                </div>
               
              </div>
              @if(this.enableUpdate) {
              <button mat-stroked-button class="w-100 mt-3" color="primary" (click)="updateWidgetValues()">Update
                component</button>
              }
            </div>
          </mat-expansion-panel>
          <ng-container [ngTemplateOutlet]="actionsTemplate" *ngIf="widgetActionsandValidations[selectedWidgetMetaData.widgetType].action.length > 0"></ng-container>
          <ng-container [ngTemplateOutlet]="validationsTemplate" *ngIf="widgetActionsandValidations[selectedWidgetMetaData.widgetType].validation.length > 0"></ng-container>
        </form>
      </ng-container>

      <!-- need inputs -->
      <ng-container *ngSwitchCase="widgetTypes.radio">
        <form [formGroup]="radioButtonGroup">
          <ng-container [ngTemplateOutlet]="widgetId"></ng-container>
          <mat-divider></mat-divider>
          <mat-expansion-panel [expanded]="widgetChange" (closed)="widgetChange = false">
            <mat-expansion-panel-header>
              <mat-panel-title> Input Properties </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="ps-4 mat-form-field-container">
              <mat-form-field appearance="outline">
                <mat-label>Title</mat-label>
                <input matInput type="text" formControlName="title"/>
                <mat-error class="text-danger" *ngIf="radioButtonGroup.get('title')?.value?.trim().length == 0">Enter value to the title</mat-error>
              </mat-form-field>


              <ng-container
                *ngFor="let value of selectedWidgetMetaData.widgetDataSource.datasource; let itemIndex = index; let isLast =last">
                <mat-form-field appearance="outline" [color]="showRadioErrorMessage[itemIndex] ? 'warn' : 'primary'">
                  <mat-label>Label</mat-label>
                  <input matInput type="text" required="true" [value]="value.label"
                    (input)="updateRadioValue($event,itemIndex,value)" />
                    @if([appPermissions.editPage,permissionsActions.edit] | builderPermissions){
                  <mat-icon style="cursor: pointer;" class="control-buttons" color="warn" *ngIf="itemIndex > 1" matSuffix
                    (click)="deleteRadioOption(itemIndex)">delete</mat-icon>
                  }
                    <mat-hint class="error-message" *ngIf="showRadioErrorMessage[itemIndex] && !isLabelEmpty">Enter value to the label</mat-hint>
                    <mat-hint class="error-message" *ngIf="isLabelEmpty && isLast">Enter value to the label</mat-hint>
                  </mat-form-field>
                </ng-container>
                <p style="color: red;" *ngIf="showRadioValueError !== ''">{{showRadioValueError}}</p>
                @if(enableUpdate){
                  <button mat-stroked-button class="w-100 mb-3" color="primary" matTooltip="Add Another Radio Option"
                  (click)="AddRadioOption()">
                    <mat-icon>add</mat-icon> Add Value
                  </button>
                }

                <mat-form-field appearance="outline">
                  <mat-label>Top Margin</mat-label>
                  <input matInput type="number"  formControlName="marginTop" (keydown.enter)="$event.preventDefault()"/>
                </mat-form-field>

              <div class="theming-color-items">
                <div class="color-item">
                  <div class="content">
                    <div class="label">Text Color</div>
                    <div class="value">{{ radioButtonGroup.get('textColor')?.value }}</div>
                  </div>
                  <div [style.background-color]="radioButtonGroup.get('textColor')?.value" mat-ripple
                    class="color-thumb">
                    <input type="color" formControlName="textColor" />
                  </div>
                </div>
              </div>
              @if(this.enableUpdate) {
              <button mat-stroked-button class="w-100 mt-3" color="primary" (click)="updateWidgetValues()">Update
                component</button>
              }
            </div>
          </mat-expansion-panel>

          <ng-container [ngTemplateOutlet]="actionsTemplate" *ngIf="widgetActionsandValidations[selectedWidgetMetaData.widgetType].action.length > 0"></ng-container>
          <ng-container [ngTemplateOutlet]="validationsTemplate" *ngIf="widgetActionsandValidations[selectedWidgetMetaData.widgetType].validation.length > 0"></ng-container>
        </form>
      </ng-container>

      <!-- done  -->
      <ng-container *ngSwitchCase="widgetTypes.dropdown">
        <form [formGroup]="selectGroup">
          <ng-container [ngTemplateOutlet]="widgetId"></ng-container>
          <mat-divider></mat-divider>
          <mat-expansion-panel [expanded]="widgetChange" (closed)="widgetChange = false">
            <mat-expansion-panel-header>
              <mat-panel-title> Input Properties </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="ps-4 mat-form-field-container">

              <mat-form-field  appearance="outline">
                <mat-label>Display Type</mat-label>
                <mat-select formControlName="matUiType">
                  <mat-option value="filled">Filled</mat-option>
                  <mat-option value="outlined">Outlined</mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Label</mat-label>
                <input matInput formControlName="label" type="text" />
                <mat-error class="text-danger" *ngIf="selectGroup.get('label')?.hasError('required')">Enter value to the label</mat-error>
              </mat-form-field>


              <mat-form-field appearance="outline">
                <mat-label>DropDown Type</mat-label>
                <mat-select formControlName="type">
                  <mat-option value="SingleSelect">Single select</mat-option>
                  <mat-option value="MultiSelect">Multi select</mat-option>
                  <mat-option value="SingleSelectSearchable">Searchable single select</mat-option>
                  <mat-option value="MultiSelectSearchable">Searchable multi select</mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Top Margin</mat-label>
                <input matInput type="number"  formControlName="marginTop" (keydown.enter)="$event.preventDefault()"/>
              </mat-form-field>

              <div class="theming-color-items">
                <div class="color-item">
                  <div class="content">
                    <div class="label">Text Color</div>
                    <div class="value">{{selectGroup.get('textColor')?.value}}</div>
                  </div>
                  <div [style.background-color]="selectGroup.get('textColor')?.value" mat-ripple class="color-thumb">
                    <input type="color" formControlName="textColor" />
                  </div>
                </div>
              </div>
              @if(this.enableUpdate) {
              <button mat-stroked-button class="w-100 mt-3" color="primary" (click)="updateWidgetValues()">Update
                component</button>
              }
            </div>
          </mat-expansion-panel>


          <ng-container [ngTemplateOutlet]="validationsTemplate" *ngIf="widgetActionsandValidations[selectedWidgetMetaData.widgetType].validation.length > 0"></ng-container>
          <ng-container [ngTemplateOutlet]="dataSource"></ng-container>
          <ng-container [ngTemplateOutlet]="actionsTemplate" *ngIf="widgetActionsandValidations[selectedWidgetMetaData.widgetType].action.length > 0"></ng-container>
        </form>
      </ng-container>

      <!-- done  -->
      <ng-container *ngSwitchCase="widgetTypes.searchableDropdown">
        <form [formGroup]="selectGroup">
          <mat-form-field appearance="outline" class="w-100 rounded-0 mat-no-hint">
            <mat-label>Key</mat-label>
            <input matInput type="text" formControlName="key" />
          </mat-form-field>
          <mat-divider></mat-divider>
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title> Input Properties </mat-panel-title>
            </mat-expansion-panel-header>

            <mat-form-field appearance="outline">
              <mat-label>Label</mat-label>
              <input matInput formControlName="label" type="text" />
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label> Data Label</mat-label>
              <mat-select formControlName="type">
                <mat-option value="Text">Text</mat-option>
                <mat-option value="Number">Number</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Placeholder</mat-label>
              <input matInput formControlName="placeholder" type="text" />
            </mat-form-field>
            <div class="color-item">
              <label class="color-label">Text/Icon Color</label>
              <input type="color" formControlName="textColor" />
              <div class="color-preview" [style.background-color]="selectGroup.get('textColor')?.value"></div>
            </div>
            @if(this.enableUpdate) {
            <button mat-stroked-button class="w-100 mt-3" color="primary" (click)="updateWidgetValues()">Update
              component</button>
            }
          </mat-expansion-panel>

          <ng-container [ngTemplateOutlet]="actionsTemplate" *ngIf="widgetActionsandValidations[selectedWidgetMetaData.widgetType].action.length > 0"></ng-container>
          <ng-container [ngTemplateOutlet]="validationsTemplate"></ng-container>
          <ng-container [ngTemplateOutlet]="dataSource"></ng-container>
        </form>
      </ng-container>

      <ng-container *ngSwitchCase="widgetTypes.date">
        <form [formGroup]="dataPickerGroup">
          <ng-container [ngTemplateOutlet]="widgetId"></ng-container>
          <mat-divider></mat-divider>
          <mat-expansion-panel [expanded]="widgetChange" (closed)="widgetChange = false">
            <mat-expansion-panel-header>
              <mat-panel-title> Date Picker Properties </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="ps-4 mat-form-field-container">

              <mat-form-field appearance="outline">
                <mat-label>Display Type</mat-label>
                <mat-select formControlName="matUiType">
                  <mat-option value="filled">Filled</mat-option>
                  <mat-option value="outlined">Outlined</mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Label</mat-label>
                <input matInput type="text" formControlName="label" />
                <mat-error class="text-danger" *ngIf="dataPickerGroup.get('label')?.value?.trim().length == 0">Enter value to the label</mat-error>
              </mat-form-field>


              <mat-form-field appearance="outline">
                <mat-label>Top Margin</mat-label>
                <input matInput type="number"  formControlName="marginTop" (keydown.enter)="$event.preventDefault()"/>
              </mat-form-field>

              <mat-form-field appearance="outline" class="mt-2">
                <mat-label>Select Date Format:</mat-label>
                <mat-select formControlName="dateFormat" searchable [isObjectsList]="true" [displayKey]="'label'">
                  <mat-option *ngFor="let format of dateFormats" [value]="format.value">{{ format.label }}</mat-option>
                </mat-select>
                <mat-error class="error-message" *ngIf="dataPickerGroup.get('dateFormat')?.hasError('required')">Please
                  select date format</mat-error>
              </mat-form-field>

              <div *ngFor="let toggle of dateRangeToggles" class="outline toggle-container custom-toggle-container">
                <mat-slide-toggle [formControlName]="toggle.formControlName">
                  <span class="font-add">{{ toggle.label }}</span>
                </mat-slide-toggle>
              </div>
              
              <ng-container *ngIf="dataPickerGroup.get('dateRangeEnable')?.value == true" appearance="outline">
                <mat-form-field appearance="outline" class="mt-2">
                  <mat-label>Historical Date Range From Today</mat-label>
                  <input matInput type="number" formControlName="historicalDays" (wheel)="preventScroll($event)" >
                  <mat-error *ngIf="dataPickerGroup.get('historicalDays')?.hasError('min')">Should be greater than 0</mat-error>
                  <mat-error *ngIf="dataPickerGroup.get('historicalDays')?.hasError('required')">Please select historical days from today</mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label>Future Date Range From Today</mat-label>
                  <input matInput type="number" formControlName="futureDays" (wheel)="preventScroll($event)" >
                  <mat-error *ngIf="dataPickerGroup.get('futureDays')?.hasError('min')">Should be greater than 0</mat-error>
                  <mat-error *ngIf="dataPickerGroup.get('futureDays')?.hasError('required')">Please select future days from today</mat-error>
                </mat-form-field> 
              </ng-container>

              <div class="theming-color-items">
                <div class="color-item">
                  <div class="content">
                    <div class="label">Text Color</div>
                    <div class="value">{{ dataPickerGroup.get('textColor')?.value }}</div>
                  </div>
                  <div [style.background-color]="dataPickerGroup.get('textColor')?.value" mat-ripple
                    class="color-thumb">
                    <input type="color" formControlName="textColor" />
                  </div>
                </div>
              </div>
              @if(this.enableUpdate) {
              <button mat-stroked-button class="w-100 mt-3" color="primary" (click)="updateWidgetValues()">Update
                component</button>
              }
            </div>
          </mat-expansion-panel>
          <ng-container [ngTemplateOutlet]="validationsTemplate" *ngIf="widgetActionsandValidations[selectedWidgetMetaData.widgetType].validation.length > 0"></ng-container>
        </form>
      </ng-container>

      <ng-container *ngSwitchCase="widgetTypes.imageUploader">
        <form [formGroup]="imageUploaderGroup">
          <ng-container [ngTemplateOutlet]="widgetId"></ng-container>
          <mat-divider></mat-divider>
      
          <mat-expansion-panel [expanded]="widgetChange" (closed)="widgetChange = false">
            <mat-expansion-panel-header>
              <mat-panel-title>Image Property</mat-panel-title>
            </mat-expansion-panel-header>
            <div class="ps-4 mat-form-field-container">
              
              <div class="image-upload mt-4 mb-4" style="margin-top: 15px;" matRipple (click)="openMediaPopUp($event)" [class.screenblur]="spinnerActive">
                <div class="w-100 d-flex justify-content-center" *ngIf="loading">
                  <mat-spinner  id="image-uploader" [diameter]="20" class="spinner"></mat-spinner>
                </div>
                <img [src]="blobUrl ?? s3ImageUrl" alt="widget background" class="w-100" *ngIf="!loading"  loading="lazy"  (error)="loading = false">
                @if(!loading){
                  <div class="edit-icon control-buttons" *ngIf="[appPermissions.editPage,permissionsActions.edit] | builderPermissions">
                    <mat-icon>edit</mat-icon>
                  </div>
                }
                <div *ngIf="spinnerActive" [class.spinnerCenter]="spinnerActive">
                  <mat-spinner diameter="40"></mat-spinner>  
                </div>
              </div>

              <mat-form-field appearance="outline" class="mat-no-hint">
                <mat-label>Top Margin</mat-label>
                <input matInput type="number" formControlName="marginTop" (keydown.enter)="$event.preventDefault()"/>
              </mat-form-field>
              @if(this.enableUpdate) {
            <button mat-stroked-button class="w-100 mt-3" color="primary" (click)="updateWidgetImageAndValues()">Update
              component</button>
            }
            </div>
          </mat-expansion-panel>
          <ng-container [ngTemplateOutlet]="actionsTemplate" *ngIf="widgetActionsandValidations[selectedWidgetMetaData.widgetType].action.length > 0"></ng-container>
        </form>
       
      </ng-container>

      <ng-container *ngSwitchCase="widgetTypes.navText">
        <form [formGroup]="navTextGroup">
          <ng-container [ngTemplateOutlet]="widgetId"></ng-container>
          <mat-divider></mat-divider>
          <mat-expansion-panel [expanded]="widgetChange" (closed)="widgetChange = false">
            <mat-expansion-panel-header>
              <mat-panel-title> Nav Title Properties </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="ps-4 mat-form-field-container">
              <mat-form-field appearance="outline">
                <mat-label>Title</mat-label>
                <input matInput type="text" formControlName="label" />
              </mat-form-field>
              <div class="spacer"></div>
              <div class="theming-color-items">
                <div class="color-item">
                  <div class="content">
                    <div class="label">Text Color</div>
                    <div class="value">{{ navTextGroup.get('textColor')?.value }}</div>
                  </div>
                  <div [style.background-color]="navTextGroup.get('textColor')?.value" mat-ripple class="color-thumb">
                    <input type="color" formControlName="textColor" />
                  </div>
                </div>
              </div>
              @if(this.enableUpdate) {
              <button mat-stroked-button class="w-100 mt-3" color="primary" (click)="updateWidgetValues()">Update
                component</button>
              }
            </div>
          </mat-expansion-panel>
          <ng-container [ngTemplateOutlet]="actionsTemplate" *ngIf="widgetActionsandValidations[selectedWidgetMetaData.widgetType].action.length > 0"></ng-container>


        </form>
      </ng-container>

      <ng-container *ngSwitchCase="widgetTypes.navButton">
        <form [formGroup]="navButtonGroup">
          <ng-container [ngTemplateOutlet]="widgetId"></ng-container>
          <mat-divider></mat-divider>

          <mat-expansion-panel [expanded]="widgetChange" (closed)="widgetChange = false">
            <mat-expansion-panel-header>
              <mat-panel-title> Button Styling </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="ps-4 mat-form-field-container">
              <mat-form-field appearance="outline">
                <mat-label>Display Icon</mat-label>
                <mat-select formControlName="image">
                  <ng-container *ngIf="this.widgetIndex == 0; else noIconSelect">
                    <mat-option value="menu" (click)="addMenuPanel()">Menu <mat-icon>menu</mat-icon></mat-option>
                    <mat-option value="arrow_back" (click)="collapseMenu()">Back Arrow <mat-icon>arrow_back</mat-icon></mat-option>
                  </ng-container>
                  <ng-template #noIconSelect>
                    <mat-option value="arrow_forward">Next Arrow <mat-icon>arrow_forward</mat-icon></mat-option>
                    <mat-option value="logout">Logout <mat-icon>logout</mat-icon></mat-option>
                    <mat-option value="sync">Sync <mat-icon>sync</mat-icon></mat-option>
                    <mat-option value="message">Chat Icon<mat-icon>message</mat-icon></mat-option>
                    <mat-option value="save">Save<mat-icon>save</mat-icon></mat-option>
                  </ng-template>
              </mat-select>
              </mat-form-field>

              <ng-container *ngIf="navButtonGroup.get('image')?.value === 'message'">
                <mat-form-field appearance="outline">
                  <mat-label>Connected Worker Application Id</mat-label>
                  <input matInput type="text" formControlName="connectedWorkerApplicationId"/>
                </mat-form-field>
                <mat-form-field appearance="outline" >
                  <mat-label>Connected Worker Customer Id</mat-label>
                  <input matInput type="text" formControlName="connectedWorkerCustomerId"/>
                </mat-form-field>
              </ng-container>
              <ng-container *ngIf="navButtonGroup.get('image')?.value == 'menu' && hasMenu">
                <div class="toggle-container">
                  <ng-container [formGroup]="showMenuGroup">
                    <mat-slide-toggle formControlName="showMenu">
                      Display Menu
                    </mat-slide-toggle>
                  </ng-container>
                  </div>

                    <mat-list *ngIf="showMenuGroup.get('showMenu')?.value">
                      <div class="toggle-container" *ngFor="let widget of menupaneldetails.widgets; let i = index">
                        <mat-slide-toggle [checked]="widget.widgetConfig?.enable" (change)="toggleWidgetStatus(widget,i,$event)">
                          {{ widget.widgetLabel | titlecase}}
                          </mat-slide-toggle>
                      </div>
                    </mat-list>
              </ng-container>

              <div class="theming-color-items">
                <div class="color-item">
                  <div class="content">
                    <div class="label">Icon Color</div>
                    <div class="value">{{ navButtonGroup.get('textColor')?.value }}</div>
                  </div>
                  <div [style.background-color]="
                      navButtonGroup.get('textColor')?.value
                    " mat-ripple class="color-thumb">
                    <input type="color" formControlName="textColor" />
                  </div>
                </div>
              </div>
              <button mat-stroked-button class="w-100 mt-3" color="primary" (click)="updateWidgetValues()">Update
                component</button>
            </div>
          </mat-expansion-panel>
          <ng-container *ngIf="navButtonGroup.get('image')?.value?.trim() !== 'menu' || widgetActionsandValidations[selectedWidgetMetaData.widgetType].validation.length > 0" [ngTemplateOutlet]="actionsTemplate"></ng-container>
        </form>
      </ng-container>
    <ng-container *ngSwitchCase="widgetTypes.scanner">
      <form [formGroup]="scannerGroup">
        <ng-container [ngTemplateOutlet]="widgetId"></ng-container>
        <mat-divider></mat-divider>
    
        <mat-expansion-panel [expanded]="widgetChange" (closed)="widgetChange = false">
          <mat-expansion-panel-header>
            <mat-panel-title>Scanner Property</mat-panel-title>
          </mat-expansion-panel-header>
          <div class="ps-4 mat-form-field-container">
            
            <mat-form-field appearance="outline">
              <mat-label>Display Type</mat-label>
              <mat-select formControlName="matUiType">
                <mat-option value="filled">Filled</mat-option>
                <mat-option value="outlined">Outlined</mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" appearance="outline">
              <mat-label>Label</mat-label>
              <input matInput type="text" formControlName="label" />
              <mat-error class="text-danger" *ngIf="scannerGroup.get('label')?.value?.trim().length == 0">Enter value to the label</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" appearance="outline">
              <mat-label>Placeholder</mat-label>
              <input matInput type="text" formControlName="placeholder" />
            </mat-form-field>

            <mat-form-field appearance="outline" appearance="outline">
              <mat-label>Top Margin</mat-label>
              <input matInput type="number" formControlName="marginTop" (keydown.enter)="$event.preventDefault()"/>
            </mat-form-field>
            <div class="theming-color-items">
            <div class="color-item">
              <div class="content">
                <div class="label">Icon Color</div>
                <div class="value">{{ scannerGroup.get('textColor')?.value }}</div>
              </div>
              <div [style.background-color]="
                      scannerGroup.get('textColor')?.value
                    " mat-ripple class="color-thumb">
                <input type="color" formControlName="textColor" />
              </div>
              </div>
             </div>
             @if(this.enableUpdate) {
          <button mat-stroked-button class="w-100 mt-3" color="primary" (click)="updateWidgetValues()">Update
            component</button>
          }
          </div>
        </mat-expansion-panel>
      </form>
      <ng-container [ngTemplateOutlet]="actionsTemplate" *ngIf="widgetActionsandValidations[selectedWidgetMetaData.widgetType].action.length > 0"></ng-container>
      <ng-container [ngTemplateOutlet]="validationsTemplate" *ngIf="widgetActionsandValidations[selectedWidgetMetaData.widgetType].validation.length > 0"></ng-container>
    </ng-container>

    <ng-container *ngSwitchCase="widgetTypes.separator">
      <form [formGroup]="separatorGroup">
        <ng-container [ngTemplateOutlet]="widgetId"></ng-container>
        <mat-divider></mat-divider>
    
        <mat-expansion-panel [expanded]="widgetChange" (closed)="widgetChange = false">
          <mat-expansion-panel-header>
            <mat-panel-title>Separator Property</mat-panel-title>
          </mat-expansion-panel-header>

          <div class="ps-4 mat-form-field-container">
            <mat-form-field appearance="outline">
              <mat-label>Thickness</mat-label>
              <input matInput type="number"[min]="1"  formControlName="thickness" />
              <mat-error *ngIf="separatorGroup.get('thickness')?.hasError('min')">
                value must be at least 1
              </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Top Margin</mat-label>
              <input matInput type="number" formControlName="marginTop" (keydown.enter)="$event.preventDefault()"/>
            </mat-form-field>
          <div class="theming-color-items">
            <div class="color-item">
              <div class="content">
                <div class="label">Color</div>
                <div class="value">{{ separatorGroup.get('textColor')?.value }}</div>
              </div>
              <div [style.background-color]="separatorGroup.get('textColor')?.value" mat-ripple class="color-thumb">
                <input type="color" formControlName="textColor" />
              </div>
            </div>
          </div>
          @if(this.enableUpdate) {
          <button mat-stroked-button class="w-100 mt-3" color="primary" [disabled]="separatorGroup.invalid" (click)="updateWidgetValues()">Update
            component</button>
          }
          </div>
        </mat-expansion-panel>
      </form>
    </ng-container>

    <ng-container *ngSwitchCase="widgetTypes.geotag">
      <form [formGroup]="geoGroup">
        <ng-container [ngTemplateOutlet]="widgetId"></ng-container>
        <mat-divider></mat-divider>
    
        <mat-expansion-panel [expanded]="widgetChange" (closed)="widgetChange = false">
          <mat-expansion-panel-header>
            <mat-panel-title>Geo Property</mat-panel-title>
          </mat-expansion-panel-header>
          <div class="ps-4 mat-form-field-container">
            <mat-form-field appearance="outline">
              <mat-label>Label</mat-label>
              <input matInput type="text" formControlName="label" />
              <mat-error class="text-danger" *ngIf="geoGroup.get('label')?.value?.trim().length == 0">Enter value to the label</mat-error>
            </mat-form-field>


            <mat-form-field appearance="outline">
              <mat-label>Top Margin</mat-label>
              <input matInput type="number"   formControlName="marginTop" (keydown.enter)="$event.preventDefault()"/>
            </mat-form-field>
          <div class="theming-color-items">
            <div class="color-item">
              <div class="content">
                <div class="label">Text Color</div>
                <div class="value">{{ geoGroup.get('textColor')?.value }}</div>
              </div>
              <div [style.background-color]="geoGroup.get('textColor')?.value" mat-ripple class="color-thumb">
                <input type="color" formControlName="textColor" />
              </div>
            </div>
          </div>
          @if(this.enableUpdate) {
          <button mat-stroked-button class="w-100 mt-3" color="primary" (click)="updateWidgetValues()">Update
            component</button>
          }
          </div>
        </mat-expansion-panel>
        <ng-container [ngTemplateOutlet]="validationsTemplate" *ngIf="widgetActionsandValidations[selectedWidgetMetaData.widgetType].validation.length > 0"></ng-container>
      </form>
    </ng-container>

    <ng-container *ngSwitchCase="widgetTypes.geofence">
      <form [formGroup]="geoFenceGroup">
        <ng-container [ngTemplateOutlet]="widgetId"></ng-container>
        <mat-divider></mat-divider>
    
        <mat-expansion-panel [expanded]="widgetChange" (closed)="widgetChange = false">
          <mat-expansion-panel-header>
            <mat-panel-title>Geofence Property</mat-panel-title>
          </mat-expansion-panel-header>
          <div class="ps-4 mat-form-field-container">
            <mat-form-field appearance="outline">
              <mat-label>Label</mat-label>
              <input matInput type="text" formControlName="label" />
              <mat-error class="text-danger" *ngIf="geoFenceGroup.get('label')?.value?.trim().length == 0">Enter value to the label</mat-error>
            </mat-form-field>


            <mat-form-field appearance="outline">
              <mat-label>Top Margin</mat-label>
              <input matInput type="number"   formControlName="marginTop" (keydown.enter)="$event.preventDefault()"/>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Select Geofence Types:</mat-label>
              <mat-select formControlName="geofenceTypes">
                <mat-option value="walking">Walking</mat-option>
                <mat-option value="manual">Manual</mat-option>
              </mat-select>
              <mat-error class="text-danger" *ngIf="geoFenceGroup.get('geofenceTypes')?.hasError('required')">Please select geofence types</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Select Geofence Shape:</mat-label>
              <mat-select formControlName="geofenceShape">
                <mat-option value="line">Line</mat-option>
                <mat-option value="points">Points</mat-option>
                <mat-option value="polygon">Polygon</mat-option>
              </mat-select>
              <mat-error class="text-danger" *ngIf="geoFenceGroup.get('geofenceShape')?.hasError('required')">Please select geofence shape</mat-error>
            </mat-form-field>

          <div class="theming-color-items">
            <div class="color-item">
              <div class="content">
                <div class="label">Text Color</div>
                <div class="value">{{ geoFenceGroup.get('textColor')?.value }}</div>
              </div>
              <div [style.background-color]="geoFenceGroup.get('textColor')?.value" mat-ripple class="color-thumb">
                <input type="color" formControlName="textColor" />
              </div>
            </div>
          </div>
          @if(this.enableUpdate) {
          <button mat-stroked-button class="w-100 mt-3" color="primary" (click)="updateWidgetValues()">Update
            component</button>
          }
          </div>
        </mat-expansion-panel>
        <ng-container [ngTemplateOutlet]="validationsTemplate" *ngIf="widgetActionsandValidations[selectedWidgetMetaData.widgetType].validation.length > 0"></ng-container>
      </form>
    </ng-container>

    <ng-container *ngSwitchCase="widgetTypes.address">
      <form [formGroup]="addressGroup">
        <ng-container [ngTemplateOutlet]="widgetId"></ng-container>
        <mat-divider></mat-divider>

        <mat-expansion-panel [expanded]="widgetChange" (closed)="widgetChange = false">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <div class="panal" style="display: flex;">
                <div class="panal-title"> Address Properties</div>
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <div class="ps-4 mat-form-field-container">

            <mat-form-field appearance="outline">
              <mat-label>Display Type</mat-label>
              <mat-select formControlName="matUiType">
                <mat-option value="filled">Filled</mat-option>
                <mat-option value="outlined">Outlined</mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Label</mat-label>
              <input matInput type="text" formControlName="label" />
              <mat-error class="text-danger" *ngIf="addressGroup.get('label')?.value?.trim().length == 0"> Enter value to the label</mat-error>
            </mat-form-field>



            <mat-form-field appearance="outline">
              <mat-label>Placeholder</mat-label>
              <input matInput type="text" formControlName="placeholder" />
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Top Margin</mat-label>
              <input matInput type="number" formControlName="marginTop" (keydown.enter)="$event.preventDefault()"/>
            </mat-form-field>

            <div class="theming-color-items">
              <div class="color-item">
                <div class="content">
                  <div class="label">Text Color</div>
                  <div class="value">{{addressGroup.get('textColor')?.value}}</div>
                </div>
                <div [style.background-color]="addressGroup.get('textColor')?.value" mat-ripple class="color-thumb">
                  <input type="color" formControlName="textColor" />
                </div>
              </div>
            </div>
            @if(this.enableUpdate) {
            <button mat-stroked-button class="w-100 mt-3" color="primary" (click)="updateWidgetValues()">Update
              component</button>
            }
          </div>
        </mat-expansion-panel>
        <ng-container [ngTemplateOutlet]="actionsTemplate" *ngIf="widgetActionsandValidations[selectedWidgetMetaData.widgetType].action.length > 0"></ng-container>
        <ng-container [ngTemplateOutlet]="validationsTemplate" *ngIf="widgetActionsandValidations[selectedWidgetMetaData.widgetType].validation.length > 0"></ng-container>
      </form>
    </ng-container>

    <ng-container *ngSwitchCase="widgetTypes.datalist">
      <form [formGroup]="dataListGroup">
        <ng-container [ngTemplateOutlet]="widgetId"></ng-container>
        <mat-divider></mat-divider>

        <mat-expansion-panel  [expanded]="widgetChange" (closed)="widgetChange = false">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <div class="panal" style="display: flex;">
                <div class="panal-title"> Data List Properties</div>
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <div class="ps-4 mat-form-field-container">
            <mat-accordion togglePosition="before" displayMode="flat">
                <mat-form-field class="w-100" appearance="outline">
                  <mat-label>Data List Type</mat-label>
                  <mat-select formControlName="type"  disableRipple>
                    <mat-option *ngFor="let option of ['Card', 'Approvals']" [value]="option">
                      {{ option }}</mat-option>
                  </mat-select>
                </mat-form-field>
           
                <mat-form-field class="w-100" appearance="outline">
                  <mat-label>Entity</mat-label>
                  <mat-select (click)="isEntityClicked()"
                    (selectionChange)="onEntitySelected()" formControlName="entity" disableRipple searchable [isObjectsList]="true" [displayKey]="'entity_name'">
                    <mat-option *ngFor="let option of listOfEntitiesOfApplication" [value]="option.entity_id">
                      {{ option.entity_name }}</mat-option>
                    </mat-select>
                    <mat-hint class="error-message small" *ngIf=" isEntityTouched && listOfEntitiesOfApplication.length==0">Entity not found. Please create an entity first.</mat-hint>
                    <mat-error class="small" *ngIf="dataListGroup.get('entity')?.hasError('required') &&  listOfEntitiesOfApplication.length>0 ">Please select an option from the dropdown</mat-error>
                    <mat-error class="small" *ngIf="dataListGroup.get('entity')?.hasError('required') &&  listOfEntitiesOfApplication.length==0">Entity not found. Please create an entity first.</mat-error>
                    
                </mat-form-field>

                <mat-form-field class="w-100" appearance="outline">
                  <mat-label>Group By</mat-label>
                  <mat-select formControlName="groupBy"  disableRipple  searchable [isObjectsList]="true" [displayKey]="'widgetLabel'">
                    <mat-option *ngFor="let option of getGroupByOptions()" [value]="option.widgetId">
                      {{ option?.widgetLabel ? option?.widgetLabel : '' }}</mat-option>
                  </mat-select>
                </mat-form-field>
              
              <div class="pt-2">
                <mat-expansion-panel>
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      <div class="panal" style="display: flex;">
                        <div class="panal-title"> {{dataListGroup.get('type')?.value === 'Approvals' ? 'Approval' :'Card'}} design</div>
                      </div>
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <div class="d-flex flex-column gap-3">
                    <div class="mb-inner-pennal">
                      <h6 class="titl">LHS</h6>
                      <div formArrayName="lhsItems" class="d-flex flex-column gap-2 mb-2">
                        <ng-container *ngFor="let item of lhsItems.controls; let leftIndex = index">
                          <div [formGroupName]="leftIndex" class="d-flex gap-2 align-items-center">
                            <mat-form-field class="w-100" appearance="outline">
                              <mat-label>Select Field</mat-label>
                              <mat-select formControlName="widgetId" disableRipple searchable [isObjectsList]="true" [displayKey]="'widgetLabel'">
                                <mat-option *ngFor="let option of getFilteredOptions(leftIndex,'lhs')" [value]="option.widgetId">
                                  {{ option?.widgetLabel ? option?.widgetLabel : '' }}</mat-option>
                              </mat-select>
                            </mat-form-field>
                            <div class="item-end control-buttons">
                              @if([appPermissions.editPage,permissionsActions.edit] | builderPermissions){
                              <button mat-icon-button color="warn" (click)="removeLhsFieldsInCard(leftIndex,item.value?.widgetId)" aria-label="Example icon button with a menu icon" class="control-buttons">
                                <mat-icon class="control-buttons">delete</mat-icon>
                              </button>
                            }
                            </div>
                          </div>
                          <mat-error *ngIf="filterWidgetList.length==0 && isLhsclicked">No attributes found in the entity</mat-error>
                        </ng-container>
                      </div>
                      <button mat-stroked-button (click)="addLhsFieldsInCard()" class="w-100 " color="primary" [disabled]="(lhsItems.controls?.length ?? 0) + (rhsItems.controls?.length ?? 0) === filterWidgetList?.length">
                        <mat-icon>add</mat-icon> Add Field</button>
                    </div>
                    <div class="mb-inner-pennal">
                      <h6 class="titl">RHS</h6>
                      <div formArrayName="rhsItems" class="d-flex flex-column gap-2 mb-2">
                        <ng-container *ngFor="let item of rhsItems.controls; let rightIndex = index">
                          <div [formGroupName]="rightIndex" class="d-flex gap-2 align-items-center">
                            <mat-form-field class="w-100" appearance="outline">
                              <mat-label>Select Field</mat-label>
                              <mat-select
                                formControlName="widgetId"  disableRipple searchable [isObjectsList]="true" [displayKey]="'widgetLabel'">
                                <mat-option *ngFor="let option of getFilteredOptions(rightIndex,'rhs')" [value]="option.widgetId">
                                  {{ option?.widgetLabel ? option?.widgetLabel : '' }}</mat-option>
                              </mat-select>
                            </mat-form-field>
                            <div class="item-end control-buttons">
                              @if([appPermissions.editPage,permissionsActions.edit] | builderPermissions){
                              <button mat-icon-button color="warn" (click)="removeRhsFieldsInCard(rightIndex,item.value?.widgetId)" aria-label="Example icon button with a menu icon">
                                <mat-icon>delete</mat-icon>
                              </button>
                            }
                            </div>
                          </div>
                          <mat-error *ngIf="filterWidgetList.length==0 && isRhsclicked">No attributes found in the entity</mat-error>
                        </ng-container>
                      </div>
                      <button mat-stroked-button (click)="addRhsFieldsInCard()" class="w-100" color="primary" [disabled]="(lhsItems.controls?.length ?? 0) + (rhsItems.controls?.length ?? 0) === filterWidgetList?.length">
                        <mat-icon>add</mat-icon> Add Field</button>
                    </div>
                  </div>
                </mat-expansion-panel>
                <mat-expansion-panel>
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      Add ons
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <div class="toggle-container custom-toggle-container">
                    <mat-slide-toggle class="w-100" formControlName="mysubmission" checked><span class="font-add">My Request</span></mat-slide-toggle>       
                  </div>
                 
                  <div class="toggle-container custom-toggle-container">
                    <mat-slide-toggle class="w-100" formControlName="search" checked><span class="font-add">Search</span></mat-slide-toggle>       
                  </div>

                  <div class="toggle-container custom-toggle-container">
                    <mat-slide-toggle class="w-100" formControlName="sort" ><span class="font-add">Sort</span></mat-slide-toggle>       
                  </div>

                  @if(dataListGroup.get('sort')?.value){
                    <mat-form-field class="w-100 mt-2 mat-no-hint" appearance="outline" >
                      <mat-label>Sort type</mat-label>
                      <mat-select formControlName="defaultSortType"  disableRipple>
                        <mat-option *ngFor="let option of ['asc', 'desc']" [value]="option">
                          {{ option | titlecase }}</mat-option>
                      </mat-select>
                    </mat-form-field>

                    <mat-form-field class="w-100 mt-2 mat-no-hint" appearance="outline" >
                      <mat-label>Default sort fields</mat-label>
                      <mat-select formControlName="defaultSortField" multiple disableRipple  searchable [isObjectsList]="true" [displayKey]="'widgetLabel'">
                        <mat-option *ngFor="let widget of combinedItems" [value]="widget.widgetId">
                          {{ widget?.widgetLabel ?? 'widget' | titlecase }}</mat-option>
                      </mat-select>
                    </mat-form-field>
    
                    <mat-form-field class="w-100 mt-2 mat-no-hint" appearance="outline" >
                      <mat-label>Sort fields</mat-label>
                      <mat-select formControlName="sortFields" multiple searchable [isObjectsList]="false">
                        <mat-option *ngFor="let widget of combinedItems" [value]="widget.widgetId">
                          {{ widget?.widgetLabel | titlecase }}</mat-option>
                      </mat-select>
                    </mat-form-field>

                    <!-- sort fields mapping  -->
                    <div class="mt-3" *ngIf="sortFieldsMapping.controls.length">Sort config </div>
                    <div formArrayName="sortConfig" class="mt-2">
                        <div *ngFor="let mapping of sortFieldsMapping.controls; let i = index" [formGroupName]="i"
                        class="d-flex flex-column align-items-center mb-2"
                        style="border: 1px solid #ccc; padding: 10px; border-radius: 5px;">
                        <p class="mb-2 align-self-start">{{ getCombinedWidgetLabel(mapping.value.widgetId) }}</p>
                        <mat-form-field class="w-100" appearance="outline">
                          <mat-label>Sort Label</mat-label> 
                          <input matInput formControlName="label" >
                        </mat-form-field>
                        <mat-form-field class="w-100" appearance="outline">
                          <mat-label>Applies To</mat-label>
                          <mat-select formControlName="appliesTo" multiple>
                          <mat-option *ngFor="let widget of combinedItems" [value]="widget.widgetId">
                            {{ widget.widgetLabel }}
                          </mat-option>
                          </mat-select>
                        </mat-form-field>
                        </div>
                    </div>
                  }
                 
                  <div class="toggle-container custom-toggle-container">
                    <mat-slide-toggle class="w-100" formControlName="filter" checked><span class="font-add">Filter</span></mat-slide-toggle>       
                  </div>
                  <mat-form-field class="w-100" appearance="outline" *ngIf="dataListGroup.get('filter')?.value">
                    <mat-label>Filter page</mat-label>
                    <mat-select formControlName="filterFormId"  disableRipple searchable [isObjectsList]="true" [displayKey]="'pageName'">
                      <mat-option *ngFor="let page of validPages" [value]="page.pageId">
                        {{ page.pageName }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                  
                  <div class="toggle-container custom-toggle-container">
                    <mat-slide-toggle class="w-100" formControlName="delete" checked><span class="font-add">Delete</span></mat-slide-toggle>       
                  </div>

                  <div class="toggle-container custom-toggle-container">
                    <mat-slide-toggle class="w-100" formControlName="download" checked><span class="font-add">Download</span></mat-slide-toggle>       
                  </div>
                  <mat-form-field class="w-100 mt-2 mat-no-hint" appearance="outline" *ngIf="dataListGroup.get('download')?.value">
                    <mat-label>Download type</mat-label>
                    <mat-select formControlName="downloadType"  disableRipple>
                      <mat-option *ngFor="let option of ['attachment', 'submissions']" [value]="option">
                        {{ option }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                  
                  <mat-form-field class="w-100 mt-2 mat-no-hint" appearance="outline" *ngIf="dataListGroup.get('download')?.value && dataListGroup.get('downloadType')?.value === 'submissions'">
                    <mat-label>Select fields</mat-label>
                    <mat-select formControlName="widgets"  disableRipple multiple (selectionChange)="downloadPdfFieldsSelection($event,dataListGroup)" searchable [isObjectsList]="true" [displayKey]="'widgetLabel'">
                      <mat-option *ngFor="let option of getFilteredOptions(0,'all')" [value]="option.widgetId">
                        {{ option?.widgetLabel | titlecase }}</mat-option>
                    </mat-select>
                  </mat-form-field>
  
                  <mat-form-field class="w-100 mt-2 mat-no-hint" appearance="outline" *ngIf="dataListGroup.get('download')?.value && dataListGroup.get('downloadType')?.value === 'submissions'">
                    <mat-label>File type</mat-label>
                    <mat-select formControlName="fileType" multiple searchable [isObjectsList]="false">
                      <mat-option *ngFor="let option of datalistDownloadFileTypes" [value]="option">
                        {{ option | titlecase }}</mat-option>
                    </mat-select>
                  </mat-form-field>


                </mat-expansion-panel>
                <mat-expansion-panel>
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      Edit configuration
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                 
                  <div class="toggle-container custom-toggle-container">
                    <mat-slide-toggle class="w-100" formControlName="edit" checked><span class="font-add">Edit</span></mat-slide-toggle>       
                  </div>
                  <mat-form-field class="w-100" appearance="outline" *ngIf="dataListGroup.get('edit')?.value">
                    <mat-label>Entry Page</mat-label>
                    <mat-select formControlName="entryPageId" disableRipple searchable [isObjectsList]="true" [displayKey]="'pageName'">
                      <mat-option *ngFor="let option of pagesList" [value]="option.pageId">
                        {{ option.pageName }}</mat-option>
                      </mat-select>
                      <mat-error class="small" *ngIf="dataListGroup.get('entryPageId')?.hasError('required') &&  pagesList.length>0 ">Please select an option from the dropdown</mat-error>
                      <button mat-icon-button matIconSuffix *ngIf="dataListGroup.get('entryPageId')?.value" (click)="dataListGroup.get('entryPageId')?.reset()" color="warn"><mat-icon>close</mat-icon></button>
                  </mat-form-field>
                </mat-expansion-panel>
              </div>
              <div class="pt-2">
               
              </div>
              @if(this.enableUpdate) {
              <button mat-stroked-button class="w-100 mt-3" color="primary" [disabled]="isDataListViewPageCreating" (click)="updateWidgetValues()">Update
                component</button> }
            </mat-accordion>
          </div>
        </mat-expansion-panel>
        <mat-expansion-panel (opened)="datalistPreviewSetter()">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <div class="panal" style="display: flex;">
                <div class="panal-title">Data List Display View</div>
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="d-flex flex-column gap-3">
            <mat-list>
              <mat-list-item  *ngIf="listOfWidgetsOfEntity.length > 0">  
                <div class="app-name">
                  <p class="title ellipsis-input fw-bold">{{"Select all" | titlecase}}</p>
                  <mat-checkbox [checked]="dataListWidgetSelectAllToggle" (change)="selectAllDataListWidgets($event)" >
    </mat-checkbox>
                </div>
              </mat-list-item>
              <mat-list-item  class="app-name" *ngFor="let item of listOfWidgetsOfEntity;let j = index" class=""> 
                <div class="app-name">
                  <p class="title ellipsis-input" [matTooltip]="item.widgetLabel">{{item.widgetLabel | titlecase}}</p>
                  @if(this.enableUpdate) {
                  <mat-slide-toggle [(ngModel)]="item.show" [ngModelOptions]="{standalone: true}" (change)="updateSelectAllToggleStatus();updateWidgetValues();"></mat-slide-toggle>
                  }
                </div> 
              </mat-list-item>
            </mat-list>
            <mat-error class="gap-3" *ngIf="listOfWidgetsOfEntity.length==0">No attributes found in the entity</mat-error>
          </div>
          @if(this.enableUpdate) {
          <button mat-stroked-button class="w-100 mt-3" [disabled]="listOfWidgetsOfEntity.length==0 || isDataListViewPageCreating" color="primary" (click)="createOrUpdateDataListViewPage()">{{currentWidgetPreviewPageExits ? 'Update' : 'Create'}}
            Data List View Page</button>
          }
        </mat-expansion-panel>
       </form>
    </ng-container>

    <ng-container *ngSwitchCase="widgetTypes.dataBoard">
      <form [formGroup]="dataBoardGroup" (ngSubmit)="updateWidgetValues(dataBoardGroup)">
        <ng-container [ngTemplateOutlet]="widgetId"></ng-container>
        <mat-divider></mat-divider>

        <mat-expansion-panel  expanded="true">  
          <mat-expansion-panel-header>
            <mat-panel-title>
              <div class="panal" style="display: flex;">
                <div class="panal-title"> Data board properties</div>
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="ps-4 mat-form-field-container">
            <mat-accordion togglePosition="before" displayMode="flat">

              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Label</mat-label>
                <input matInput formControlName="label" />
                <mat-error class="small" *ngIf="dataBoardGroup.get('label')?.hasError('required')">Enter value to the label </mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Select board type</mat-label>
                <mat-select formControlName="type" >
                  <mat-option *ngFor="let item of [dataBoardTypes.display,dataBoardTypes.aggregator]" [value]="item">
                    {{ item | titlecase}}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Select API</mat-label>
                <mat-select formControlName="dataSource" (selectionChange)="onDataBoardApiSeletion($event)" searchable [isObjectsList]="true" [displayKey]="'apiName'">
                  @for (apisGroup of apis; track apisGroup) {
                    <mat-optgroup [label]="apisGroup.name | titlecase" >
                      @for (api of apisGroup.apis; track api.apiId) {
                        <mat-option [value]="api.apiId">{{api.apiName | titlecase}}</mat-option>
                      }
                    </mat-optgroup>
                  }
                </mat-select>
                <mat-error class="small" *ngIf="dataBoardGroup.get('dataSource')?.hasError('required') &&  entityList.length>0 ">Please select an option from the dropdown</mat-error>
              </mat-form-field>

              @if(dataBoardGroup.get('dataSource')?.value == 'entitySubmisionsList' || dataBoardGroup.get('dataSource')?.value == 'dashBoardWorkflowBased' || dataBoardGroup.get('dataSource')?.value == 'dashboardUserBased' ){
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Select entity</mat-label>
                  <mat-select formControlName="entityId" (click)="isEntityClicked()" (selectionChange)="onEntitySelected($event,true)"  searchable [isObjectsList]="true" [displayKey]="'entity_name'">
                    <mat-option *ngFor="let entity of entityList" [value]="entity.entity_id">
                      {{ entity.entity_name | titlecase}}
                    </mat-option>
                  </mat-select>
                  <mat-hint class="error-message small" *ngIf=" isEntityTouched && entityList.length==0">Entity not found. Please create an entity first.</mat-hint>
                  <mat-error class="small" *ngIf="dataBoardGroup.get('entityId')?.hasError('required') &&  entityList.length>0 ">Please select an option from the dropdown</mat-error>
                  <mat-error class="small" *ngIf="dataBoardGroup.get('entityId')?.hasError('required') &&  entityList.length==0">Entity not found. Please create an entity first.</mat-error>
                </mat-form-field>

              }

              @if( dataBoardGroup.get('dataSource')?.value == 'dashBoardWorkflowBased' &&  dataBoardGroup.get('entityId')?.value){
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Select widget</mat-label>
                  <mat-select formControlName="widgetId" searchable [isObjectsList]="true" [displayKey]="'widgetLabel'" >
                    <mat-option *ngFor="let widget of listOfWidgetsOfEntity" [value]="widget.widgetId" >
                      {{widget.widgetLabel | titlecase}}
                    </mat-option>
                  </mat-select>
                  <mat-error class="small" *ngIf="dataBoardGroup.get('widgetId')?.hasError('required')">{{ listOfWidgetsOfEntity.length>0 ? "Please select an option from the dropdown" : "No widgets found"}}</mat-error>
                </mat-form-field>
                
              }
          
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Select primary</mat-label>
                <mat-select formControlName="primary"  searchable [isObjectsList]="true" [displayKey]="'widgetLabel'">
                  <mat-option *ngFor="let widget of dataBoardEntityBasedWidgets" [value]="widget.widgetId" >
                    {{ widget.widgetLabel | titlecase}}
                  </mat-option>
                </mat-select>
                <mat-error class="small" *ngIf="dataBoardGroup.get('primary')?.hasError('required') &&  entityList.length>0 ">Please select an option from the dropdown</mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Select secondary</mat-label>
                <mat-select formControlName="secondary" searchable [isObjectsList]="true" [displayKey]="'widgetLabel'">
                  @for(widget of dataBoardEntityBasedWidgets;track widget){
                    <mat-option [value]="widget.widgetId" *ngIf="widget.widgetId !== dataBoardGroup.get('primary')?.value">
                      {{ widget.widgetLabel | titlecase}}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
                        
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Max rows</mat-label>
                <input matInput formControlName="maxRows" libPositiveIntegerInput type="number" />
              </mat-form-field>

              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <mat-panel-title>Header design</mat-panel-title>
                </mat-expansion-panel-header>
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Header type</mat-label>
                  <mat-select formControlName="headertype">
                    <mat-option *ngFor="let option of [databoardHeaderTypes.generic,databoardHeaderTypes.custom]" [value]="option">
                      {{ option | titlecase}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                @if(dataBoardGroup.get('headertype')?.value === databoardHeaderTypes.custom){
                  <mat-form-field appearance="outline" class="mat-no-hint w-100">
                    <mat-label>Header</mat-label>
                    <input type="text" matInput formControlName="customHeader">
                  </mat-form-field>
                  <div class="toggle-container custom-toggle-container">
                    <mat-slide-toggle class="w-100 m-1" formControlName="aggregate" ><span class="font-add">Aggregate</span></mat-slide-toggle>       
                  </div>
                }@else{
                  <div class="toggle-container custom-toggle-container">
                    <mat-slide-toggle class="w-100" formControlName="customLabels" (change)="buildDataBoardCustomHeaders($event)" ><span class="font-add">Custom Labels</span></mat-slide-toggle>       
                  </div>

                  @if(dataBoardGroup.get('customLabels')?.value){
                    @for(customheader of dataBoardGroup.get('lhsItemsCustomLabel')?.value;track customheader){
                      <mat-form-field appearance="outline" class="mat-no-hint w-100 mb-2">
                        <mat-label>{{customheader.original | titlecase}}</mat-label>
                        <input type="text" matInput [(ngModel)]="customheader.custom"  [ngModelOptions]="{standalone: true}">
                      </mat-form-field>
                    }
                  }
                }
              </mat-expansion-panel>


             
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <mat-panel-title>Add ons</mat-panel-title>
                </mat-expansion-panel-header>
                <div class="toggle-container custom-toggle-container">
                  <mat-slide-toggle class="w-100 m-1" formControlName="serialNumber" ><span class="font-add">Serial number</span></mat-slide-toggle>       
                </div>
                <div class="toggle-container custom-toggle-container">
                  <mat-slide-toggle class="w-100 m-1" formControlName="search" ><span class="font-add">Search</span></mat-slide-toggle>       
                </div>
                <div class="toggle-container custom-toggle-container">
                  <mat-slide-toggle class="w-100 m-1" formControlName="download" ><span class="font-add">Download</span></mat-slide-toggle>       
                </div>
                <mat-form-field class="w-100 mt-2 mat-no-hint" appearance="outline" *ngIf="dataBoardGroup.get('download')?.value">
                  <mat-label>Download type</mat-label>
                  <mat-select formControlName="downloadType"  disableRipple>
                    <mat-option *ngFor="let option of ['attachment', 'submissions']" [value]="option">
                      {{ option }}</mat-option>
                  </mat-select>
                </mat-form-field>
                
                <mat-form-field class="w-100 mt-2 mat-no-hint" appearance="outline" *ngIf="dataBoardGroup.get('download')?.value && dataBoardGroup.get('downloadType')?.value === 'submissions'">
                  <mat-label>Select fields</mat-label>
                  <mat-select formControlName="widgets"  disableRipple multiple (selectionChange)="downloadPdfFieldsSelection($event,dataBoardGroup)" searchable [isObjectsList]="true" [displayKey]="'widgetLabel'">
                    <mat-option *ngFor="let option of getFilteredOptions(0,'all')" [value]="option.widgetId">
                      {{ option?.widgetLabel | titlecase }}</mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-form-field class="w-100 mt-2 mat-no-hint" appearance="outline" *ngIf="dataBoardGroup.get('download')?.value && dataBoardGroup.get('downloadType')?.value === 'submissions'">
                  <mat-label>File type</mat-label>
                  <mat-select formControlName="fileType" multiple >
                    <mat-option *ngFor="let option of datalistDownloadFileTypes" [value]="option">
                      {{ option | titlecase }}</mat-option>
                  </mat-select>
                </mat-form-field>
              </mat-expansion-panel>
            </mat-accordion>
            @if(this.enableUpdate) {
            <button mat-stroked-button class="w-100 mt-3" color="primary" >Update
              component</button>
            }
          </div>
        </mat-expansion-panel>
        

      
      </form>
      <ng-container [ngTemplateOutlet]="actionsTemplate" *ngIf="widgetActionsandValidations[selectedWidgetMetaData.widgetType].action.length > 0"></ng-container>
    </ng-container>

    <ng-container *ngSwitchCase="widgetTypes.faceId">
      <form [formGroup]="faceIdGroup">
        <ng-container [ngTemplateOutlet]="widgetId"></ng-container>
        <mat-divider></mat-divider>
    
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>Face Id Property</mat-panel-title>
          </mat-expansion-panel-header>
          <div class="ps-4 mat-form-field-container">

            <mat-form-field appearance="outline">
              <mat-label>Top Margin</mat-label>
              <input matInput type="number" formControlName="marginTop" (keydown.enter)="$event.preventDefault()"/>
             
            </mat-form-field>
            @if(this.enableUpdate) {
          <button mat-stroked-button class="w-100 mt-3" color="primary" (click)="updateWidgetValues()">Update
            component</button>
          }
          </div>
        </mat-expansion-panel>
        <ng-container [ngTemplateOutlet]="actionsTemplate" *ngIf="widgetActionsandValidations[selectedWidgetMetaData.widgetType].action.length > 0"></ng-container>
      </form>
     
    </ng-container>

    <ng-container *ngSwitchCase="widgetTypes.fingerPrint">
      <form [formGroup]="touchIdGroup">
        <ng-container [ngTemplateOutlet]="widgetId"></ng-container>
        <mat-divider></mat-divider>
    
        <mat-expansion-panel [expanded]="widgetChange" (closed)="widgetChange = false">
          <mat-expansion-panel-header>
            <mat-panel-title>Biometrics Property</mat-panel-title>
          </mat-expansion-panel-header>
          <div class="ps-4 mat-form-field-container">
            <mat-form-field appearance="outline">
              <mat-label>Top Margin</mat-label>
              <input matInput type="number" formControlName="marginTop" (keydown.enter)="$event.preventDefault()"/>
              
            </mat-form-field>
            @if(this.enableUpdate) {
          <button mat-stroked-button class="w-100 mt-3" color="primary" (click)="updateWidgetValues()">Update
            component</button>
          }
          </div>
        </mat-expansion-panel>
        <ng-container [ngTemplateOutlet]="actionsTemplate" *ngIf="widgetActionsandValidations[selectedWidgetMetaData.widgetType].action.length > 0"></ng-container>
      </form>
     
    </ng-container>

    <!-- printer -->
    <ng-container *ngSwitchCase="widgetTypes.printer">
      <form [formGroup]="printerGroup">
        <ng-container [ngTemplateOutlet]="widgetId"></ng-container>
        <mat-divider></mat-divider>
        <mat-expansion-panel [expanded]="widgetChange" (closed)="widgetChange = false">
          <mat-expansion-panel-header>
            <mat-panel-title> Printer Properties </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="ps-4 mat-form-field-container">
            <mat-form-field appearance="outline">
              <mat-label>Display Type</mat-label>
              <mat-select formControlName="matUiType">
                <mat-option value="filled">Filled</mat-option>
                <mat-option value="outlined">Outlined</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Text</mat-label>
              <input matInput type="text" formControlName="label" (input)="updateWidgetLabel()" (keydown.enter)="$event.preventDefault()"/>
              <mat-error class="text-danger" *ngIf="printerGroup.get('label')?.value?.trim().length == 0">Enter value to the label</mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>ZPL Formater</mat-label>
              <textarea  matInput formControlName="image" placeholder="Enter ZPL code here" Rows="10" Cols="50" spellcheck="false" class="no-resize"></textarea>
              <mat-hint class="w-100 SmallSize">ZPL Editor : <a href="https://labelary.com/viewer.html" target="_blank">Labelary Online ZPL Viewer</a> </mat-hint>
              <mat-error class="text-danger" *ngIf="printerGroup.get('image')?.value?.trim().length == 0">Enter value to the textfield</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="mt-3">
              <mat-label>Top Margin</mat-label>
              <input matInput type="number" formControlName="marginTop" (keydown.enter)="$event.preventDefault()" />
            </mat-form-field>

            <div class="theming-color-items">
              <div class="color-item">
                <div class="content">
                  <div class="label">Button Color</div>
                  <div class="value">{{ printerGroup.get('bgColor')?.value }}</div>
                </div>
                <div [style.background-color]="printerGroup.get('bgColor')?.value" mat-ripple class="color-thumb">
                  <input type="color" formControlName="bgColor" />
                </div>
              </div>

              <div class="color-item">
                <div class="content">
                  <div class="label">Text/Icon Color</div>
                  <div class="value">{{ printerGroup.get('textColor')?.value }}</div>
                </div>
                <div [style.background-color]="
                    printerGroup.get('textColor')?.value
                  " mat-ripple class="color-thumb">
                  <input type="color" formControlName="textColor" />
                </div>
              </div>
            </div>
            @if(this.enableUpdate) {
            <button mat-stroked-button class="w-100 mt-3" color="primary" (click)="updateWidgetValues()">Update
              component</button>
            }
          </div>
        </mat-expansion-panel>
        <ng-container [ngTemplateOutlet]="actionsTemplate" *ngIf="widgetActionsandValidations[selectedWidgetMetaData.widgetType].action.length > 0"></ng-container>
      </form>
    </ng-container>

    <ng-container *ngSwitchCase="widgetTypes.chatView">
      <form [formGroup]="chatViewgroup">
        <ng-container [ngTemplateOutlet]="widgetId"></ng-container>
        <mat-divider></mat-divider>
        <mat-expansion-panel [expanded]="widgetChange" (closed)="widgetChange = false">
          <mat-expansion-panel-header>
            <mat-panel-title> Chat View Properties </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="ps-4 mat-form-field-container">
            <mat-form-field appearance="outline">
              <mat-label>Text</mat-label>
              <input matInput type="text" formControlName="label"  (keydown.enter)="$event.preventDefault()"/>
              <mat-error class="text-danger" *ngIf="chatViewgroup.get('label')?.value?.trim().length == 0">Enter value to the label</mat-error>
            </mat-form-field>
          
            <mat-label>Chat Avatar</mat-label>
            <mat-radio-group aria-label="Select an option" formControlName="isLogo">
              <mat-radio-button [value]="1">App Logo</mat-radio-button>
              <mat-radio-button [value]="2" class="ms-0">2 Letters of Name</mat-radio-button>
            </mat-radio-group>
            @if(this.enableUpdate) {
            <button mat-stroked-button class="w-100 mt-3" color="primary" (click)="updateWidgetValues()">Update
              component</button>
            }
          </div>
        </mat-expansion-panel>
      </form>
    </ng-container>
  
    <ng-container *ngSwitchCase="widgetTypes.barChart" [ngTemplateOutlet]="barOrLineCharConfig">
    </ng-container>

    <ng-container *ngSwitchCase="widgetTypes.lineChart" [ngTemplateOutlet]="barOrLineCharConfig">
    </ng-container>

    <ng-container *ngSwitchCase="widgetTypes.pieChart" [ngTemplateOutlet]="barOrLineCharConfig">
    </ng-container>

    <ng-container *ngSwitchCase="widgetTypes.donutChart" [ngTemplateOutlet]="barOrLineCharConfig">
    </ng-container>

    <ng-container *ngSwitchCase="widgetTypes.stackBarChart" [ngTemplateOutlet]="barOrLineCharConfig">
    </ng-container>

    <ng-container *ngSwitchCase="widgetTypes.fixedBarChart" [ngTemplateOutlet]="barOrLineCharConfig">
    </ng-container>
    
    <ng-container *ngSwitchCase="widgetTypes.chatBot">
      <form [formGroup]="chatBotConfigurationForm">
        <ng-container [ngTemplateOutlet]="widgetId"></ng-container>
        <mat-divider></mat-divider>
        <mat-expansion-panel [expanded]="widgetChange" (closed)="widgetChange = false">
          <mat-expansion-panel-header>
            <mat-panel-title> Chat bot Properties </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="ps-4 mat-form-field-container">
            <mat-accordion togglePosition="before" displayMode="flat">
              <h6 class="label heading">Global Configuration</h6>
              <div class="theming-color-items mb-3">
                <div class="color-item">
                  <div class="content">
                    <div class="label"> Background Color</div>
                    <div class="value">{{ chatBotConfigurationForm.get('bgColor')?.value }}</div>
                  </div>
                  <div [style.background-color]="chatBotConfigurationForm.get('bgColor')?.value" mat-ripple class="color-thumb">
                    <input type="color" formControlName="bgColor" />
                  </div>
                </div>

                <div class="color-item">
                  <div class="content">
                    <div class="label">Text Color</div>
                    <div class="value">{{ chatBotConfigurationForm.get('textColor')?.value }}</div>
                  </div>
                  <div [style.background-color]="
                  chatBotConfigurationForm.get('textColor')?.value
                    " mat-ripple class="color-thumb">
                    <input type="color" formControlName="textColor" />
                  </div>
                </div>
              </div>
              <h6 class="label mb-2">Upload Bot Avatar & Select Shape</h6>
              <div class="file-upload">
                <input type="file" id="fileInput" (change)="onFileSelected($event,widgetTypes.chatBot)" hidden>
                <mat-form-field appearance="outline" style="flex: 1">
                  <mat-label>Upload bot avatar</mat-label>
                  <div class="d-flex justify-content-between gap-2">
                    <input matInput [value]="chatBotConfigurationForm.value.avatarFileName" readonly>
                    <mat-icon *ngIf="chatBotConfigurationForm.value.avatarFileName" class="cursor-pointer" mat-icon-button matSuffix color="warn" (click)="removeFile()">close</mat-icon>
                    <mat-icon color="primary" class="cursor-pointer" (click)="triggerFileInput()">file_upload</mat-icon>                 
                  </div>
                </mat-form-field>
              </div>
              <div class="chat-avator-pic">
                <div class="recangle" (click)="selectedShape('rectangle')"  [class.active]="chatBotConfigurationForm.get('avatarShape')?.value == 'rectangle'">
                  <img [src]="selectedImage()" class="h-100 w-100" alt="">
                </div>

                <div class="circle" (click)="selectedShape('circle')" [class.active]="chatBotConfigurationForm.get('avatarShape')?.value == 'circle'">
                  <img [src]="selectedImage()" class="h-100 w-100" alt="">
                </div>
                <div class="avatar-rounded" (click)="selectedShape('rounded')" [class.active]="chatBotConfigurationForm.get('avatarShape')?.value == 'rounded'">
                  <img [src]="selectedImage()" class="h-100 w-100" alt="">
                </div>
              </div>
              <div class="mb-20">
                <h6 for="" class="label m-0"> User Avatar</h6>
              <div class="d-flex">
                <mat-radio-group aria-label="Select an option" formControlName="userAvatar">
                  <mat-radio-button value="profilePic">Profile Pic</mat-radio-button>
                  <mat-radio-button value="twoLettersOfName" class="m-0">2 Letter of Name</mat-radio-button>
                </mat-radio-group>
              </div>
              </div>
              <h6 class="label">Panel Configuration</h6>
              <!-- <mat-form-field appearance="outline" class="w-100">
                <mat-label>Width</mat-label>
                <input matInput type="number" formControlName="panelWidth" />
              </mat-form-field> -->
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Height</mat-label>
                <input matInput type="number" min="400" formControlName="panelHeight" />
                <mat-error *ngIf="chatBotConfigurationForm.get('panelHeight')?.hasError('min')">Minimum height should be 400</mat-error>
              </mat-form-field>
              <div class="mb-20">
                <h6 class="label ">Footer Configuration</h6>
              <div class="theming-color-items">
                <div class="color-item">
                  <div class="content">
                    <div class="label"> Button Color</div>
                    <div class="value">{{ chatBotConfigurationForm.get('footerButtonColor')?.value }}</div>
                  </div>
                  <div [style.background-color]="chatBotConfigurationForm.get('footerButtonColor')?.value" mat-ripple class="color-thumb">
                    <input type="color" formControlName="footerButtonColor" />
                  </div>
                </div>

                <div class="color-item">
                  <div class="content">
                    <div class="label">Text Color</div>
                    <div class="value">{{ chatBotConfigurationForm.get('footerTextColor')?.value }}</div>
                  </div>
                  <div [style.background-color]="
                  chatBotConfigurationForm.get('footerTextColor')?.value
                    " mat-ripple class="color-thumb">
                    <input type="color" formControlName="footerTextColor" />
                  </div>
                </div>

                <div class="color-item">
                  <div class="content">
                    <div class="label">Border Color</div>
                    <div class="value">{{ chatBotConfigurationForm.get('footerBorderColor')?.value }}</div>
                  </div>
                  <div [style.background-color]="
                  chatBotConfigurationForm.get('footerBorderColor')?.value
                    " mat-ripple class="color-thumb">
                    <input type="color" formControlName="footerBorderColor" />
                  </div>
                </div>
              </div>
              </div>
              <div class="toggle-group">
                <div class="app-name">
                  <p class="title ellipsis-input" > Attachments</p>
                  <mat-slide-toggle formControlName="showAttachmentsIcon"></mat-slide-toggle>
                </div> 
                <div class="app-name">
                  <p class="title ellipsis-input" > Text</p>
                  <mat-slide-toggle formControlName="showTextInput"></mat-slide-toggle>
                </div> 
                <div class="app-name">
                  <p class="title ellipsis-input" > Speech</p>
                  <mat-slide-toggle formControlName="showSpeechIcon"></mat-slide-toggle>
                </div> 
                <div class="app-name">
                  <p class="title ellipsis-input" > Send</p>
                  <mat-slide-toggle formControlName="showSendIcon"></mat-slide-toggle>
                </div> 
              </div>
              @if(this.enableUpdate) {
              <button mat-stroked-button class="w-100 mt-3" color="primary" [disabled]="!isChatBotFormEnabled" (click)="updateWidgetValues()">Update
                component</button>
              }
            </mat-accordion>
          </div>
        </mat-expansion-panel>
      </form>
    </ng-container>

    <ng-container *ngSwitchCase="widgetTypes.overviewTracker">
      <form [formGroup]="overviewTrackerGroup">
        <ng-container [ngTemplateOutlet]="widgetId"></ng-container>
        <mat-divider></mat-divider>

        <mat-expansion-panel  expanded="true">  
          <mat-expansion-panel-header>
            <mat-panel-title>
              <div class="panal" style="display: flex;">
                <div class="panal-title"> Overview tracker properties</div>
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="ps-4 mat-form-field-container">
            <mat-accordion togglePosition="before" displayMode="flat">

              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Label</mat-label>
                <input matInput formControlName="label" />
                <mat-error class="small" *ngIf="overviewTrackerGroup.get('label')?.hasError('required')">Enter value to the label </mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Select source</mat-label>
                <mat-select formControlName="dataSource" (selectionChange)="onDataBoardApiSeletion($event)" searchable [isObjectsList]="true" [displayKey]="'apiName'">
                  @for (apisGroup of apis; track apisGroup) {
                    <mat-optgroup [label]="apisGroup.name | titlecase" >
                      @for (api of apisGroup.apis; track api.apiId) {
                        <mat-option [value]="api.apiId">{{api.apiName | titlecase}}</mat-option>
                      }
                    </mat-optgroup>
                  }
                </mat-select>
                <mat-error class="small" *ngIf="overviewTrackerGroup.get('dataSource')?.hasError('required')">Please select an option from the dropdown</mat-error>
              </mat-form-field>

              @if(['dashboardUserBased','entitySubmisionsList','dashBoardWorkflowBased'].includes(overviewTrackerGroup.get('dataSource')?.value)){
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Select Entity</mat-label>
                    <mat-select formControlName="entityId" (click)="isEntityClicked()" (selectionChange)="onEntitySelected($event,true)" searchable [isObjectsList]="true" [displayKey]="'entity_name'">
                    <mat-option *ngFor="let entity of entityList" [value]="entity.entity_id">
                      {{ entity.entity_name | titlecase}}
                    </mat-option>
                  </mat-select>
                  <mat-hint class="error-message small" *ngIf=" isEntityTouched && entityList.length==0">Entity not found. Please create an entity first.</mat-hint>
                  <mat-error class="small" *ngIf="overviewTrackerGroup.get('entityId')?.hasError('required') &&  entityList.length>0 ">Please select an option from the dropdown</mat-error>
                  <mat-error class="small" *ngIf="overviewTrackerGroup.get('entityId')?.hasError('required') &&  entityList.length==0">Entity not found. Please create an entity first.</mat-error>
                </mat-form-field>
              }
          
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Primary</mat-label>
                <mat-select formControlName="primary" searchable [isObjectsList]="true" [displayKey]="'widgetLabel'">
                  <mat-option *ngFor="let widget of dataBoardEntityBasedWidgets" [value]="widget.widgetId">
                    {{ widget.widgetLabel | titlecase}}
                  </mat-option>
                </mat-select>
                <mat-error class="small" *ngIf="overviewTrackerGroup.get('primary')?.hasError('required')">Please select an option from the dropdown</mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Secondary</mat-label>
                <mat-select formControlName="secondary" searchable [isObjectsList]="true" [displayKey]="'widgetLabel'">
                  @for(widget of dataBoardEntityBasedWidgets;track widget){
                    <mat-option [value]="widget.widgetId" *ngIf="widget.widgetId !== overviewTrackerGroup.get('primary')?.value">
                      {{ widget.widgetLabel | titlecase}}
                    </mat-option>
                  }
                </mat-select>
                <mat-error class="small" *ngIf="overviewTrackerGroup.get('secondary')?.hasError('required')">Please select an option from the dropdown</mat-error>
              </mat-form-field>



              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Status label</mat-label>
                <mat-select formControlName="statusLabel">
                  <mat-option *ngFor="let item of apikeys" [value]="item">
                    {{ item | titlecase }}
                  </mat-option>
                </mat-select>
                <mat-error class="small" *ngIf="overviewTrackerGroup.get('statuses')?.hasError('required')">Please select an option from the dropdown</mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Status</mat-label>
                <mat-select formControlName="statuses" multiple (selectionChange)="statusTracerStatusesSelectionChange($event)">
                  <mat-option *ngFor="let item of apikeys" [value]="item">
                    {{ item | titlecase }}
                  </mat-option>
                </mat-select>
                <mat-error class="small" *ngIf="overviewTrackerGroup.get('statuses')?.hasError('required')">Please select an option from the dropdown</mat-error>
              </mat-form-field>

              @if(overviewTrackerGroup.get('statuses')?.value?.length > 0){
                @for(statusObj of overviewTrackerGroup.get('statusesColorCode')?.value;track statusObj){
                  <div class="theming-color-items mb-2">
                      <div class="px-3 mt-2 fw-medium">{{statusObj.status | titlecase}}</div>
                      <div class="color-item">
                        <div class="content"> 
                          <div class="label">Background color</div>
                          <div class="value">{{ statusObj.bgColor }}</div>
                        </div>
                        <div [style.background-color]="statusObj.bgColor" mat-ripple class="color-thumb">
                          <input type="color" [(ngModel)]="statusObj.bgColor" [ngModelOptions]="{standalone: true}" (ngModelChange)="statusColorCodeUpdater($event,statusObj.status,'bgColor')" />
                        </div>
                      </div>
                  
                      <div class="color-item">
                        <div class="content">
                          <div class="label">Text color</div>
                          <div class="value">{{ statusObj.textColor }}</div>
                        </div>
                        <div [style.background-color]="statusObj.textColor" mat-ripple class="color-thumb">
                          <input type="color"  [(ngModel)]="statusObj.textColor" [ngModelOptions]="{standalone: true}" (ngModelChange)="statusColorCodeUpdater($event,statusObj.status,'textColor')" />
                        </div>
                      </div>
                    </div>
                }
              }

              <mat-expansion-panel class="mt-1">
                <mat-expansion-panel-header>
                  <mat-panel-title>Header properties</mat-panel-title>
                </mat-expansion-panel-header>
                <div class="ps-4 mat-form-field-container">

                  <div class="toggle-container custom-toggle-container">
                    <mat-slide-toggle class="w-100 m-1" formControlName="legend" ><span class="font-add">Show legend</span></mat-slide-toggle>       
                    <mat-slide-toggle class="w-100 m-1" formControlName="info" ><span class="font-add">Show info</span></mat-slide-toggle>       
                  </div>
                  <mat-form-field class="mat-no-hint w-100" appearance="outline" *ngIf="overviewTrackerGroup.get('info')?.value">
                    <mat-label>Info description</mat-label>
                    <textarea type="text" matInput formControlName="infoDescription" placeholder="Short description to show in info" class="no-resize"></textarea>
                  </mat-form-field>
              </div>
              </mat-expansion-panel>
             
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <mat-panel-title>Add ons</mat-panel-title>
                </mat-expansion-panel-header>
                  <div class="toggle-container custom-toggle-container">
                    <mat-slide-toggle class="w-100 m-1" formControlName="serialNumber" ><span class="font-add">Serial number</span></mat-slide-toggle>       
                  </div>
                  <div class="toggle-container custom-toggle-container">
                    <mat-slide-toggle class="w-100 m-1" formControlName="search" ><span class="font-add">Search</span></mat-slide-toggle>       
                  </div>
              </mat-expansion-panel>

             
            </mat-accordion>
            @if(this.enableUpdate) {
            <button mat-stroked-button class="w-100 mt-3" color="primary" [disabled]="isDataListViewPageCreating" (click)="updateWidgetValues()">Update
              component</button>
            }
          </div>
        </mat-expansion-panel>
      </form>
    </ng-container>

    <ng-container *ngSwitchCase="widgetTypes.filter">
        <ng-container [ngTemplateOutlet]="widgetId"></ng-container>
        <mat-divider></mat-divider>
        <mat-expansion-panel  expanded="true">  
          <mat-expansion-panel-header>
            <mat-panel-title>
              <div class="panal" style="display: flex;">
                <div class="panal-title"> Filter properties</div>
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="ps-4 mat-form-field-container">
              <mat-accordion *ngIf="selectedWidgetMetaData.widgetConfig?.filters" togglePosition="before" displayMode="flat">
                @for(filterData of selectedWidgetMetaData.widgetConfig?.filters;track $index){
                  <mat-expansion-panel (opened)="patchFilterwidget(filterData,true)" class="mb-2 ">
                    <mat-expansion-panel-header class="mat-list-item">
                      <mat-panel-title class="item-fill  w-75">
                        <span class="text-ellipsis"> {{filterData.label|titlecase}}</span>
                       
                      </mat-panel-title>
                      <div class="item-end control-buttons">
                        @if([appPermissions.editPage,permissionsActions.edit] | builderPermissions){
                        <button mat-icon-button color="warn" (click)="removeFilter($index);$event.preventDefault()">
                          <mat-icon>delete</mat-icon>
                        </button>
                      }
                      </div>
                    </mat-expansion-panel-header >
                    <ng-container [ngTemplateOutlet]="filterFormFields" [ngTemplateOutletContext]="{ formGroup: filterUpdateGroup }"></ng-container>
                    <div class="filter-action">
                      <button mat-flat-button color="primary" (click)="updateFilter($index,filterUpdateGroup)">Update</button>
                    </div>
                  </mat-expansion-panel>

                }
              </mat-accordion>
              <div class="d-flex flex-column">
                <h6 class="mb-2">Add filter</h6>
                <ng-container [ngTemplateOutlet]="filterFormFields" [ngTemplateOutletContext]="{ formGroup: filterGroup }"></ng-container>
                <div class="filter-action">
                  <button mat-flat-button color="primary" (click)="addFilter()" [disabled]="filterGroup.invalid">Add</button>
                </div>
              </div>
              @if(this.enableUpdate) {
              <button mat-stroked-button class="w-100 mt-3" color="primary"  (click)="updateWidgetValues()">Update
                component</button> 
              }
          </div>
        </mat-expansion-panel>
    </ng-container>

    <ng-container *ngSwitchDefault>
      <p>Development in progress for {{ displayedContent }}</p>
    </ng-container>
  </div>

  <ng-template #actionsTemplate>
    <lib-widget-actions [widget]="selectedWidgetMetaData" [currentPageWidgets]="csWidgetsList" [applicationId]="applicationId" (widgetRef)="updateWidgetRef($event)" *ngIf="toggleActionsAndValidations"></lib-widget-actions>
  </ng-template>

  <ng-template #validationsTemplate>
    <lib-widget-validations [widget]="selectedWidgetMetaData" [applicationId]="applicationId" *ngIf="toggleActionsAndValidations"></lib-widget-validations>
  </ng-template>


  <ng-template #dataSource>
    <mat-expansion-panel togglePosition="before" displayMode="flat">
      <mat-expansion-panel-header>
        <mat-panel-title class="m-0">
          <span class="flex-fill"> Data Source</span>
          <mat-chip>{{selectedWidgetMetaData.widgetDataSource?.datasourceType ? 1 : 0 }}</mat-chip>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="ps-4">
        <ng-container *ngIf="dataSourceApi">

        </ng-container>
        <ng-container *ngIf="dataSourceValues">
        </ng-container>
        <form [formGroup]="dataSourceTypeForm" class="mat-form-field-container">
          <mat-form-field appearance="outline">
            <mat-label> Drop Down Type</mat-label>
            <mat-select formControlName="dataSourceType">
              <mat-option *ngFor="let type of dataSourceTypes" [value]="type">{{ type }}</mat-option>
            </mat-select>
          </mat-form-field>
        </form>
        <ng-container *ngIf="dataSourceTypeForm.get('dataSourceType')?.value === 'API'">
          <form [formGroup]="apiForm">
            <mat-form-field class="w-100 mt-3 rounded-0" appearance="outline">
              <mat-label>Select API</mat-label>
              <mat-select formControlName="apiId" (selectionChange)="makeApiCall($event)" searchable [isObjectsList]="true" [displayKey]="'apiName'">
                <mat-option *ngFor="let api of userApis" [value]="api.apiId" >{{api.apiName}}</mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field class="w-100 mt-3 rounded-0" appearance="outline">
              <mat-label>Response Parameter</mat-label>
              <mat-select formControlName="responseParameter">
                <ng-container *ngFor="let key of apikeys">
                  <mat-option [value]="key">{{key}}</mat-option>
                </ng-container>
              </mat-select>
              <mat-icon matSuffix
                matTooltip="Select the key name you want to assign to the dropdown Ex: username, if your data consists of user details"
                matTooltipPosition="after">info</mat-icon>
            </mat-form-field>
          </form>

          <button mat-stroked-button class="w-100 mt-3" color="primary" (click)="addDataSource()">Save API
            Details</button>
        </ng-container>

        <ng-container *ngIf="dataSourceTypeForm.get('dataSourceType')?.value === 'Manual'">

          <mat-list role="list">
            <mat-list-item class="item-selected"  [class.active]="i === selectedDataSourceIndex && editMode"role="listitem" *ngFor="let obj of dataSourceValues;let i = index">
              <ng-container *ngIf="dataSourceValues">
                <div class="d-flex gap-3 flex-nowrap align-items-center py-2 ps-4">
                  <div class="item-start flex-fill text-multi-line">
                    <h6 class="title">{{ obj }}</h6>
                  </div>
                  <div class="item-end control-buttons"> 
                    @if([appPermissions.editPage,permissionsActions.edit] | builderPermissions){
                    <button mat-icon-button matSuffix (click)="editDatasourceValues(i)">
                    <mat-icon>edit</mat-icon>
                  </button>
                    <button mat-icon-button matSuffix [disabled]="selectedDataSourceIndex === i" (click)="deleteDatasourceValue(i)">
                    <mat-icon>delete</mat-icon>
                  </button>
                }
                </div>
                </div>
              </ng-container>
            </mat-list-item>
          </mat-list>
          <form [formGroup]="valuesForm">
            <div>
              <form [formGroup]="valuesForm" class="mat-form-field-container">
                <mat-form-field class="w-100 mt-3" appearance="outline">
                  <mat-label>Label</mat-label>
                  <input matInput type="text" formControlName="label" (keydown.enter)="$event.preventDefault(); editMode ? updateEditedDataSource() : addDataSourceValue()" />
                  <mat-hint class="error-message" *ngIf="lableExisted">Value already exists!</mat-hint>
                  <mat-error class="error-message"
                    *ngIf="this.valuesForm.get('label')?.hasError?.('required') && this.valuesForm.get('label')?.touched">
                    please enter label!</mat-error>
                </mat-form-field>
              </form>
              <button mat-stroked-button class="w-100 mt-3" color="primary" *ngIf="!editMode" (click)="addDataSourceValue()"
                 [disabled]="this.valuesForm.get('label')?.hasError?.('required') || lableExisted">
                <mat-icon>add</mat-icon> Add Value
              </button>
              <button mat-stroked-button class="w-100 mt-3" color="primary" *ngIf="editMode" (click)="updateEditedDataSource()"
              [disabled]="this.valuesForm.get('label')?.hasError?.('required') || lableExisted">
                <mat-icon>add</mat-icon> Update Value
              </button>
            </div>
            @if([appPermissions.editPage,permissionsActions.edit] | builderPermissions){
              <button mat-stroked-button class="w-100 mt-3" color="primary" (click)="addDataSource()">Save Values</button>
            }
          </form>
        </ng-container>

        <ng-container *ngIf="dataSourceTypeForm.get('dataSourceType')?.value === 'Stage'">
          <button mat-stroked-button class="w-100 mt-3" color="primary" (click)="addDataSource()">Save</button>
        </ng-container>

        <ng-container *ngIf="dataSourceTypeForm.get('dataSourceType')?.value === 'Entity'">

          <form [formGroup]="dropdownDatasourceEntityForm">
            <mat-form-field class="w-100 mt-3 rounded-0" appearance="outline">
              <mat-label>Select entity</mat-label>
              <mat-select formControlName="entityId" (selectionChange)="onEntitySelected($event)" searchable [isObjectsList]="true" [displayKey]="'entity_name'">
                <mat-option *ngFor="let entity of entityList" [value]="entity.entity_id" >{{entity.entity_name}}</mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field class="w-100 mt-3 rounded-0" appearance="outline">
              <mat-label>select Label</mat-label>
              <mat-select formControlName="widgetId" searchable [isObjectsList]="true" [displayKey]="'widgetLabel'">
                <ng-container *ngFor="let widget of listOfWidgetsOfEntity">
                  <mat-option [value]="widget.widgetId">{{widget.widgetLabel}}</mat-option>
                </ng-container>
              </mat-select>
              <mat-icon matSuffix
                matTooltip="Select the key name you want to assign to the dropdown Ex: username, if your data consists of user details"
                matTooltipPosition="after">info</mat-icon>
            </mat-form-field>

            <mat-form-field class="w-100 mt-3 rounded-0" appearance="outline">
              <mat-label>select key</mat-label>
              <mat-select formControlName="widgetKey" searchable [isObjectsList]="true" [displayKey]="'widgetLabel'">
                <ng-container *ngFor="let widget of listOfWidgetsOfEntity">
                  <mat-option [value]="widget.widgetId">{{widget.widgetLabel}}</mat-option>
                </ng-container>
              </mat-select>
              <button mat-icon-button matIconSuffix (click)="dropdownDatasourceEntityForm.get('widgetKey')?.reset()" *ngIf="dropdownDatasourceEntityForm.get('widgetKey')?.value"><mat-icon>close</mat-icon></button>
            </mat-form-field>

            <!-- filters  -->
            <div class="sub-actions-accordion">
              <mat-accordion togglePosition="before" displayMode="flat">
              <mat-expansion-panel togglePosition="before" displayMode="flat" >
                <mat-expansion-panel-header>
                  <mat-panel-title>Filters</mat-panel-title>
                </mat-expansion-panel-header>
                <div formArrayName="filters">
                <ng-container *ngFor="let filter of dropdownDataSourceFilters.controls; let filterIndex = index">
                    <!-- widget type filter -->
                    <mat-accordion togglePosition="before" displayMode="flat">
                      <mat-expansion-panel togglePosition="before" displayMode="flat" class="mb-2">
                        <mat-expansion-panel-header>
                          <mat-panel-title>
                            <p class="label">{{filter.value.filterType | titlecase}}</p>
                            <p class="value">
                              @if(filter.value.filterType === dropdownDataSourceFilterTypes.manual){
                                {{( filter.value.ref ?? '') | titlecase}}
                              }
                            </p>
                          </mat-panel-title>
                        </mat-expansion-panel-header>
                    <div [formGroupName]="filterIndex">
                  @if(filter.value.filterType === dropdownDataSourceFilterTypes.widget){
                   
                    <ng-container [ngTemplateOutlet]="filterTypeWidget" [ngTemplateOutletContext]="{ group: filter }"></ng-container>
                  
                }@else if(filter.value.filterType === dropdownDataSourceFilterTypes.manual){
                  <ng-container [ngTemplateOutlet]="filterTypeManual" [ngTemplateOutletContext]="{ group: filter }"></ng-container>
                }
              </div>
              <div class="float-end validations-button">
                <button mat-flat-button color="warn"
                (click)="removeDataSourceFilter(filterIndex,filter.value)">Remove</button>
                </div>
              </mat-expansion-panel>
              </mat-accordion>
              </ng-container>
              </div>

              <button mat-stroked-button color="primary" class="w-100 mt-2" [matMenuTriggerFor]="filterTypes"  ><mat-icon>add</mat-icon> Add</button>
              <mat-menu #filterTypes="matMenu">
                <button mat-menu-item *ngFor="let item of dropdownDataSourceFiltersMenu;let i = index" (click)="addDataSourceFilter(item,i)">
                  {{ item | titlecase}}
                </button>
              </mat-menu>

              <mat-form-field class="w-100 mt-3 rounded-0" appearance="outline">
                      <mat-label>Select operator</mat-label>
                      <mat-select formControlName="operator">
                        <mat-option *ngFor="let operator of ['and','or']" [value]="operator" >{{operator| titlecase}}</mat-option>
                      </mat-select>
                    </mat-form-field>
              </mat-expansion-panel>
            </mat-accordion>
            </div>
          </form>
          <button mat-stroked-button class="w-100 mt-3" color="primary" [disabled]="dropdownDatasourceEntityForm.invalid" (click)="addDataSource()">Save</button>
        </ng-container>
      </div>
    </mat-expansion-panel>

  </ng-template>

  <ng-template #barOrLineCharConfig>
    <form [formGroup]="chartDetailsFormGroup">
      <ng-container [ngTemplateOutlet]="widgetId"></ng-container>
      <mat-divider></mat-divider>
      <mat-expansion-panel [expanded]="widgetChange" (closed)="widgetChange = false">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <div class="panal" class="d-flex">
              <div class="panal-title">Chart Properties</div>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="mat-form-field-container">
          <mat-accordion togglePosition="before" displayMode="flat">
            <mat-form-field class="w-100 rounded-0" appearance="outline">
              <mat-label>Title</mat-label>
              <input matInput type="text" formControlName="title" />
            </mat-form-field>
            <mat-divider></mat-divider>

            <div class="pt-2">
              <mat-expansion-panel expanded="false">
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <div class="panal" class="d-flex">
                      <div class="panal-title">Data Source</div>
                    </div>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="d-flex flex-column gap-3">
                  <div class="mb-inner-pennal">
                    <mat-form-field class="w-100 m-1" appearance="outline">
                      <mat-label>Data Source Type</mat-label>
                      <mat-select formControlName="dataSourceType" disableRipple searchable [isObjectsList]="true" [displayKey]="'label'">
                        <mat-option *ngFor="let option of chartDataSourceTypes" [value]="option.value">
                          {{ option.label }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                    <ng-container *ngIf="
                        chartDetailsFormGroup.value.dataSourceType == 'api'
                      ">
                      <div [formGroup]="selectedApiGroup">
                      <mat-form-field  class="w-100 m-1" appearance="outline">
                        <mat-label>Select Api</mat-label>
                        <mat-select formControlName="selectedApi" searchable [isObjectsList]="true" [displayKey]="'apiName'">
                          @for (apisGroup of apis; track apisGroup) {
                            <mat-optgroup [label]="apisGroup.name | titlecase" >
                              @for (api of apisGroup.apis; track api.apiId) {
                                <mat-option [value]="api.apiId">{{api.apiName | titlecase}}</mat-option>
                              }
                            </mat-optgroup>
                          }
                        </mat-select>
                      </mat-form-field>
                    </div>

                      @if(['dashboardUserBased','entitySubmisionsList','dashBoardWorkflowBased'].includes(selectedApiGroup.get('selectedApi')?.value)){
                        <mat-form-field appearance="outline" class="w-100">
                          <mat-label>Select Entity</mat-label>
                            <mat-select formControlName="entity" (click)="isEntityClicked()" (selectionChange)="onEntitySelected($event,true)"  searchable [isObjectsList]="true" [displayKey]="'entity_name'">
                            <mat-option *ngFor="let entity of entityList" [value]="entity.entity_id">
                              {{ entity.entity_name | titlecase}}
                            </mat-option>
                          </mat-select>
                          <mat-hint class="error-message small" *ngIf=" isEntityTouched && entityList.length==0">Entity not found. Please create an entity first.</mat-hint>
                          <mat-error class="small" *ngIf="chartDetailsFormGroup.get('entity')?.hasError('required') &&  entityList.length>0 ">Please select an option from the dropdown</mat-error>
                          <mat-error class="small" *ngIf="chartDetailsFormGroup.get('entity')?.hasError('required') &&  entityList.length==0">Entity not found. Please create an entity first.</mat-error>
                        </mat-form-field>
                        
                          <mat-form-field appearance="outline" class="w-100">
                            <mat-label>primary</mat-label>
                              <mat-select formControlName="primary" searchable [isObjectsList]="true" [displayKey]="'widgetLabel'">
                              <mat-option *ngFor="let widget of dataBoardEntityBasedWidgets" [value]="widget.widgetId">
                                {{ widget.widgetLabel | titlecase}}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
  
                          <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Secondary</mat-label>
                              <mat-select formControlName="secondary" searchable [isObjectsList]="true" [displayKey]="'widgetLabel'">
                                <mat-option *ngFor="let widget of dataBoardEntityBasedWidgets" [value]="widget.widgetId">
                                  {{ widget.widgetLabel | titlecase}}
                                </mat-option>
                            </mat-select>
                          </mat-form-field>
                      }
        
                     
                      <button mat-stroked-button class="w-100 mt-3" color="primary" (click)="
                          getApiOrEntityDefinitionBasedOnForm(
                            'api',
                            selectedApiGroup.get('selectedApi')?.value
                          )
                        ">
                        Get Api Definition
                      </button>
                    </ng-container>
                    <ng-container *ngIf="
                        chartDetailsFormGroup.value.dataSourceType ==
                        'entity'
                      ">
                      <mat-form-field class="w-100 rounded-0" appearance="outline">
                        <mat-label>Select Entity</mat-label>
                        <mat-select formControlName="entity" searchable [isObjectsList]="true" [displayKey]="'entity_name'">
                          <mat-option *ngFor="
                              let option of listOfEntitiesOfMobAndWebApplication
                            " [value]="option.entity_id">
                            {{ option.entity_name }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                      <button mat-stroked-button class="w-100 mt-3" color="primary" (click)="
                          getApiOrEntityDefinitionBasedOnForm(
                            'entity',
                            chartDetailsFormGroup.get('entity')?.value
                          )
                        ">
                        Get Entity Definition
                      </button>
                    </ng-container>
                  </div>
                </div>
              </mat-expansion-panel>
            </div>
            <ng-container *ngIf="displayedContent === widgetTypes.barChart || displayedContent === widgetTypes.lineChart || displayedContent === widgetTypes.stackBarChart">
              <div class="pt-2">
                <mat-expansion-panel expanded="false">
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      <div class="panal" class="d-flex">
                        <div class="panal-title">X-Axis Properties</div>
                      </div>
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <div class="d-flex flex-column gap-3">
                    <div formGroupName="xAxisProperties" class="mb-inner-pennal">
                      <mat-form-field class="w-100 rounded-0" appearance="outline">
                        <mat-label>Label</mat-label>
                        <input matInput formControlName="label" type="text" />
                      </mat-form-field>
                      <mat-form-field class="w-100 rounded-0" appearance="outline">
                        <mat-label>Categories</mat-label>
                        <mat-select formControlName="categories">
                            <mat-option *ngFor="let option of apikeys" [value]="option">
                              {{ option }}
                            </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                  </div>
                </mat-expansion-panel>
              </div>
              <div class="pt-2">
                <mat-expansion-panel>
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      <div class="panal" class="d-flex">
                        <div class="panal-title">Y-Axis Properties</div>
                      </div>
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <div class="d-flex flex-column gap-3">
                    <div formGroupName="yAxisProperties" class="mb-inner-pennal">
                      <mat-form-field class="w-100 rounded-0" appearance="outline">
                        <mat-label>Label</mat-label>
                        <input matInput formControlName="label" type="text" />
                      </mat-form-field>
                      <mat-form-field class="w-100 rounded-0" appearance="outline">
                        <mat-label>Series</mat-label>
                        <mat-select multiple formControlName="series">
                            <mat-option *ngFor="let option of apikeys" [value]="option">
                              {{ option }}
                            </mat-option>
                        </mat-select>
                      </mat-form-field>
                      <div formArrayName="individualSeriesProperties">
                        <ng-container *ngFor="
                            let item of individualSeriesProperties.controls;
                            let index = index
                          ">
                          <div [formGroupName]="index" class="properties-group">
                            <h6 class="title m-0">{{item.get('key')?.value}}</h6>
                            <mat-form-field class="w-100 mat-no-hint" appearance="outline">
                              <mat-label>Label</mat-label>
                              <input matInput formControlName="label" type="text" />
                            </mat-form-field>

                            <div class="theming-color-items">
                              <div class="color-item">
                                <div class="content">
                                  <div class="label">Text Color</div>
                                  <div class="value">{{item.get('color')?.value}}</div>
                                </div>
                                <div [style.background-color]="item.get('color')?.value" mat-ripple class="color-thumb">
                                  <input type="color" formControlName="color" />
                                </div>
                              </div>
                            </div>
                          </div>

                        </ng-container>
                      </div>
                      <div class="app-name mb-3" *ngIf="displayedContent === widgetTypes.barChart || displayedContent === widgetTypes.stackBarChart">
                        <p class="title ellipsis-input">
                          Data Labels
                        </p>
                        <mat-slide-toggle formControlName="dataLabels"></mat-slide-toggle>
                      </div>
                      <div class="app-name mb-3" *ngIf="displayedContent === widgetTypes.stackBarChart">
                        <p class="title ellipsis-input">
                          Stack Labels
                        </p>
                        <mat-slide-toggle formControlName="stackLabels"></mat-slide-toggle>
                      </div>
                    </div>
                  </div>
                </mat-expansion-panel>
              </div>
            </ng-container>


            <ng-container *ngIf="displayedContent === widgetTypes.fixedBarChart">
              <div class="pt-2">
                <mat-expansion-panel expanded="false">
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      <div class="panal" class="d-flex">
                        <div class="panal-title">X-Axis Properties</div>
                      </div>
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <div class="d-flex flex-column gap-3">
                    <div formGroupName="xAxisProperties" class="mb-inner-pennal">
                      <mat-form-field class="w-100 rounded-0" appearance="outline">
                        <mat-label>Label</mat-label>
                        <input matInput formControlName="label" type="text" />
                      </mat-form-field>
                      <mat-form-field class="w-100 rounded-0" appearance="outline">
                        <mat-label>Categories</mat-label>
                        <mat-select formControlName="categories">
                          <mat-option *ngFor="let option of apikeys" [value]="option">
                            {{ option }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                  </div>
                </mat-expansion-panel>
              </div>
              <div class="pt-2">
                <mat-expansion-panel>
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      <div class="panal" class="d-flex">
                        <div class="panal-title">Y-Axis1 Properties</div>
                      </div>
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <div class="d-flex flex-column gap-3">
                    <div formGroupName="fixedChartYAxisProperties" class="mb-inner-pennal">
                      <mat-form-field class="w-100 rounded-0" appearance="outline">
                        <mat-label>Label</mat-label>
                        <input matInput formControlName="label1" type="text" />
                      </mat-form-field>
                      <mat-form-field class="w-100 rounded-0" appearance="outline">
                        <mat-label>Series</mat-label>
                        <mat-select multiple formControlName="series1">
                          <mat-option *ngFor="let option of apikeys" [value]="option">
                            {{ option }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                      <div formArrayName="yAxis1SeriesProperties">
                        <ng-container *ngFor="
                            let item of yAxis1SeriesProperties.controls;
                            let index = index
                          ">
                          <div [formGroupName]="index">
                            <mat-form-field class="w-100 rounded-0" appearance="outline">
                              <mat-label>Label</mat-label>
                              <input matInput formControlName="label" type="text" />
                            </mat-form-field>
                            <mat-form-field class="w-100 rounded-0" appearance="outline">
                              <mat-label>Key</mat-label>
                              <input matInput formControlName="key" [value]="item" type="text" />
                            </mat-form-field>


                            <div class="color-item d-flex justify-content-between align-items-center">
                              <div class="content">
                                <div class="label">Color</div>
                              </div>
                              <div mat-ripple class="color-thumb">
                                <input type="color" formControlName="color" />
                              </div>
                            </div>
                          </div>

                        </ng-container>
                      </div>
                    </div>
                  </div>
                </mat-expansion-panel>
              </div>
              <div class="pt-2">
                <mat-expansion-panel>
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      <div class="panal" class="d-flex">
                        <div class="panal-title">Y-Axis2 Properties</div>
                      </div>
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <div class="d-flex flex-column gap-3">
                    <div formGroupName="fixedChartYAxisProperties" class="mb-inner-pennal">
                      <mat-form-field class="w-100 rounded-0" appearance="outline">
                        <mat-label>Label</mat-label>
                        <input matInput formControlName="label2" type="text" />
                      </mat-form-field>
                      <mat-form-field class="w-100 rounded-0" appearance="outline">
                        <mat-label>Series</mat-label>
                        <mat-select multiple formControlName="series2">
                          <mat-option *ngFor="let option of apikeys" [value]="option">
                            {{ option }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                      <div formArrayName="yAxis2SeriesProperties">
                        <ng-container *ngFor="
                            let item of yAxis2SeriesProperties.controls;
                            let index = index
                          ">
                          <div [formGroupName]="index">
                            <mat-form-field class="w-100 rounded-0" appearance="outline">
                              <mat-label>Label</mat-label>
                              <input matInput formControlName="label" type="text" />
                            </mat-form-field>
                            <mat-form-field class="w-100 rounded-0" appearance="outline">
                              <mat-label>Key</mat-label>
                              <input matInput formControlName="key" [value]="item" type="text" />
                            </mat-form-field>


                            <div class="color-item d-flex justify-content-between align-items-center">
                              <div class="content">
                                <div class="label">Color</div>
                              </div>
                              <div mat-ripple class="color-thumb">
                                <input type="color" formControlName="color" />
                              </div>
                            </div>
                          </div>

                        </ng-container>
                      </div>
                    </div>
                  </div>
                </mat-expansion-panel>
              </div>
            </ng-container>


            <ng-container *ngIf="displayedContent === widgetTypes.pieChart || displayedContent === widgetTypes.donutChart">
              <div class="pt-2">
                <mat-expansion-panel expanded="false">
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      <div class="panal" class="d-flex">
                        <div class="panal-title">Data Properties</div>
                      </div>
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <div class="d-flex flex-column gap-3">
                    <div formGroupName="xAxisProperties" class="mb-inner-pennal">
                      <mat-form-field class="w-100 rounded-0" appearance="outline">
                        <mat-label>Label</mat-label>
                        <mat-select formControlName="label">
                          <mat-option *ngFor="let option of apikeys" [value]="option">
                            {{ option }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                      <mat-form-field class="w-100 rounded-0" appearance="outline">
                        <mat-label>Value</mat-label>
                        <mat-select formControlName="categories">
                          <mat-option *ngFor="let option of apikeys" [value]="option">
                            {{ option }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                  </div>
                </mat-expansion-panel>
              </div>
            </ng-container>
            <div class="pt-2">
              <mat-expansion-panel expanded="false">
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <div class="panal" class="d-flex">
                      <div class="panal-title">Legend Properties</div>
                    </div>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="d-flex flex-column gap-3">
                  <div formGroupName="legendPropertyies" class="mb-inner-pennal">
                    <div class="app-name mb-3">
                      <p class="title ellipsis-input" >
                        Display Legend
                      </p>
                      <mat-slide-toggle formControlName="displayLegend"></mat-slide-toggle>
                    </div>
                    <ng-container *ngIf="
                        chartDetailsFormGroup.get('legendPropertyies')
                          ?.value.displayLegend
                      ">
                      <mat-form-field class="w-100 m-1" appearance="outline">
                        <mat-label>Legend Align Position</mat-label>
                        <mat-select formControlName="legendAlignment" disableRipple>
                          <mat-option *ngFor="
                              let option of legendAlignmentOptions
                            " [value]="option.value" >
                            {{ option.key }}</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </ng-container>
                  </div>
                </div>
              </mat-expansion-panel>
            </div>
            @if([appPermissions.editPage,permissionsActions.edit] | builderPermissions){
            <button mat-stroked-button class="w-100 mt-3" color="primary" (click)="updateDiplayWidgetValues()">
              Update component
            </button>
          }
          </mat-accordion>
        </div>
      </mat-expansion-panel>
    </form>
  </ng-template>

  </div>
</mat-accordion>
<ng-template #fontIconTemplate let-formGroup="formGroup">
  <div class="icon-container" [formGroup]="formGroup">

    <button class="fab-normal" mat-mini-fab 
    (click)="formGroup.get('bold')?.setValue(!formGroup.get('bold')?.value)" [ngClass]="{'active': formGroup.get('bold')?.value}">  
    <mat-icon>format_bold</mat-icon>
  </button>



    <button mat-mini-fab class="fab-normal"
      (click)="formGroup.get('italic')?.setValue(!formGroup.get('italic')?.value)" [ngClass]="{'active': formGroup.get('italic')?.value}">
      <mat-icon>format_italic</mat-icon>
    </button>
    <button mat-mini-fab class="fab-normal"
      (click)="formGroup.get('underline')?.setValue(!formGroup.get('underline')?.value)" [ngClass]="{'active': formGroup.get('underline')?.value}">
      <mat-icon>format_underlined</mat-icon>
    </button>
    <div class="item">
      <button mat-mini-fab class="fab-normal" (click)="formGroup?.get('fontSize')?.value > 1 && formGroup.get('fontSize')?.setValue(formGroup.get('fontSize')?.value - 1)">
        <mat-icon>remove</mat-icon>
      </button>
      <input id="fontSizeInput" [formControl]="formGroup?.get('fontSize')" (input)="onFontSizeChange($event, formGroup)" (blur)="onFontSizeBlur($event, formGroup)" />
      <button mat-mini-fab class="fab-normal" (click)="formGroup.get('fontSize')?.setValue(formGroup.get('fontSize')?.value + 1)">
        <mat-icon>add</mat-icon>
      </button>
    </div>
  </div>
</ng-template>

<ng-template #widgetId>
  <mat-toolbar>
    <span class="fs-6">Widget Id</span>
    <div class="flex-fill"></div>
    <button mat-icon-button [matTooltip]="selectedWidgetMetaData.widgetId" (click)="copyToClipboard(selectedWidgetMetaData.widgetId)">
      <mat-icon>content_copy</mat-icon>
    </button>
  </mat-toolbar>
</ng-template>

 <!-- filter form  -->
<ng-template #filterFormFields let-formGroup="formGroup">
  <form [formGroup]="formGroup">
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Filter type</mat-label>
      <mat-select formControlName="filterType" placeholder="Filter type">
        <mat-option *ngFor="let filter of filterWidgetFilterTypes" [value]="filter.id">
          {{ filter.label | titlecase}}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="formGroup.get('filterType')?.hasError('required')">Please select an option </mat-error>
    </mat-form-field>
  
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Filter label </mat-label>
      <input type="text" matInput formControlName="label" placeholder="Label">
      <mat-error *ngIf="formGroup.get('label')?.hasError('required')">Please enter a value</mat-error>
    </mat-form-field>
  
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Source </mat-label>
      <mat-select formControlName="sourceType" placeholder="Source type">
        <mat-option *ngFor="let source of ['entity','api']" [value]="source">
          {{ source | titlecase}}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="formGroup.get('sourceType')?.hasError('required')">Please select an option</mat-error>
    </mat-form-field>
    
    <mat-form-field class="w-100" appearance="outline" *ngIf="formGroup.get('sourceType')?.value == 'entity'">
      <mat-label>Entity</mat-label>
      <mat-select (click)="isEntityClicked()" (selectionChange)="onEntitySelected($event,true)" formControlName="dataSource"
      disableRipple searchable [isObjectsList]="true" [displayKey]="'entity_name'">
      <mat-option *ngFor="let option of entityList" [value]="option.entity_id">
        {{ option.entity_name }}</mat-option>
      </mat-select>
      <mat-error *ngIf="formGroup.get('dataSource')?.hasError('required')"> @if(entityList.length > 0){
        {{"Please select an option "}}
      }@else if(formGroup.get('sourceType')?.value == 'entity'){
        {{"Entity not found. Please create an entity."}}
      }</mat-error>
    </mat-form-field>
  
    <mat-form-field class="w-100" appearance="outline" *ngIf="formGroup.get('sourceType')?.value == 'api'">
      <mat-label>select Api</mat-label>
      <mat-select (selectionChange)="makeApiCall($event)" formControlName="dataSource" disableRipple searchable [isObjectsList]="true" [displayKey]="'apiName'">
        @for (apisGroup of apis; track apisGroup) {
        <mat-optgroup [label]="apisGroup.name | titlecase">
          @for (api of apisGroup.apis; track api.apiId) {
          <mat-option [value]="api.apiId">{{api.apiName | titlecase}}</mat-option>
          }
        </mat-optgroup>
        }
      </mat-select>
      <mat-error *ngIf="formGroup.get('dataSource')?.hasError('required')">Please select an option </mat-error>
    </mat-form-field>
  
    <mat-form-field appearance="outline" class="w-100" *ngIf="formGroup.get('sourceType')?.value && formGroup.get('dataSource')?.value">
      <mat-label>Based on</mat-label>
      <mat-select formControlName="basedOn" (openedChange)="filterBasedOnOptions($event,formGroup.get('filterType')?.value)" placeholder="Select field" multiple searchable [isObjectsList]="true" [displayKey]="'widgetLabel'">
        @if(formGroup.get('sourceType')?.value == 'entity'){
          <mat-option *ngFor="let widget of filterBasedOnfiledWidgetOptions" [value]="widget.widgetId">
            {{ widget.widgetLabel | titlecase}}
          </mat-option>
        }@else{
          <mat-option *ngFor="let apiKey of apikeys" [value]="apiKey">
            {{ apiKey | titlecase}}
          </mat-option>
        }
      </mat-select>
      <mat-error *ngIf="formGroup.get('basedOn')?.hasError('required')">
        @if(dataBoardEntityBasedWidgets.length > 0){
          {{"Please select an option "}}
        }@else if(formGroup.get('sourceType')?.value == 'entity'){
          {{"No widgets found"}}
        }
      </mat-error>
    </mat-form-field>
    @if(formGroup.get('filterType').value !== 'date_range'){
      <div class="toggle-container custom-toggle-container mb-2" *ngIf="formGroup.get('basedOn')?.value && formGroup.get('filterType')?.value != 'date range'">
        <mat-slide-toggle class="w-100 m-1" formControlName="manual"><span class="font-add">Custom
            Values</span></mat-slide-toggle>
      </div>
      @if(formGroup.get('manual').value){
        <mat-chip-set class="my-2">
          @for (value of formGroup.get('manualValues')?.value; track $index) {
            <mat-chip (removed)="removeCustomValue(formGroup,'manualValues',$index)" >
              {{value | truncate: 30}}
              <mat-icon matChipRemove>cancel</mat-icon>
            </mat-chip>
          }
        </mat-chip-set>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Custom value</mat-label>
          <input matInput #customValueInput placeholder="Enter a value" (keydown.enter)="addCustomValue(formGroup,'manualValues',customValueInput.value);customValueInput.value = ''" />
          <mat-icon matSuffix (click)="addCustomValue(formGroup,'manualValues',customValueInput.value);customValueInput.value = ''">add</mat-icon>
        </mat-form-field>
      }  
    }

    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Applies to</mat-label>
      <mat-select formControlName="appliesTo" placeholder="select field" multiple searchable [isObjectsList]="true" [displayKey]="'widgetLabel'">
        <mat-option *ngFor="let widget of csWidgetsList" [value]="widget.widgetId">
          {{ widget.widgetLabel | titlecase}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </form>
</ng-template>

<!-- Button widget line item action preview page config -->
 <ng-template #lineItemPreviewConfig>
  <mat-expansion-panel (opened)="datalistPreviewSetter()" togglePosition="before" displayMode="flat">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <div class="panal" style="display: flex;">
          <div class="panal-title">Data List Display View</div>
        </div>
      </mat-panel-title>
    </mat-expansion-panel-header>
    @if(dataLoading){
      <div class="imageCenter mt-5">
        <mat-spinner [diameter]="30"></mat-spinner>
      </div>
    }@else{
    <div class="d-flex flex-column gap-3">
      <mat-list>
        <mat-list-item  *ngIf="listOfWidgetsOfEntity.length > 0">  
          <div class="app-name">
            <p class="title ellipsis-input fw-bold">{{"Select all" | titlecase}}</p>
            <mat-checkbox [checked]="dataListWidgetSelectAllToggle" (change)="selectAllDataListWidgets($event)" ></mat-checkbox>
          </div>
        </mat-list-item>
        <mat-list-item  class="app-name" *ngFor="let item of listOfWidgetsOfEntity;let j = index" class=""> 
          <div class="app-name">
            <p class="title ellipsis-input" [matTooltip]="item.widgetLabel">{{item.widgetLabel | titlecase}}</p>
            @if(this.enableUpdate) {
            <mat-slide-toggle [(ngModel)]="item.show" [ngModelOptions]="{standalone: true}" (change)="updateSelectAllToggleStatus();updateWidgetValues();"></mat-slide-toggle>
            }
          </div> 
        </mat-list-item>
      </mat-list>
      <mat-error class="gap-3" *ngIf="listOfWidgetsOfEntity.length==0">No attributes found in the entity</mat-error>
    </div>
    @if(this.enableUpdate) {
    <button mat-stroked-button class="w-100 mt-3" [disabled]="listOfWidgetsOfEntity.length==0" color="primary" (click)="createOrUpdateDataListViewPage(true)">{{currentWidgetPreviewPageExits ? 'Update' : 'Create'}}
      Data List View Page</button>
    }
    }
  </mat-expansion-panel>
 </ng-template>

 <!-- dropdown dataSource FilterGroups  -->
  <ng-template #filterTypeWidget let-group="group">
    <div [formGroup]="group">
      <mat-form-field class="w-100 mt-3 rounded-0" appearance="outline">
        <mat-label>Filter type</mat-label>
        <mat-select formControlName="filterType"   searchable [isObjectsList]="true" [displayKey]="'entity_name'">
          <mat-option *ngFor="let type of [dropdownDataSourceFilterTypes.manual,dropdownDataSourceFilterTypes.widget]" [value]="type" >{{type | titlecase}}</mat-option>
        </mat-select>
      </mat-form-field>
          <mat-form-field class="w-100 mt-3 rounded-0" appearance="outline">
            <mat-label>Select entity</mat-label>
            <mat-select formControlName="basedEntitys" multiple   searchable [isObjectsList]="true" [displayKey]="'entity_name'" (selectionChange)="fetchAndPatchBasedWntityWidget($event,group)">
              <mat-option *ngFor="let entity of entityList" [value]="entity.entity_id" >{{entity.entity_name}}</mat-option>
            </mat-select>
          </mat-form-field>
      <div formArrayName="basedWidgetIds">
        <ng-container *ngFor="let entitywidgetMapping of $any(group.get('basedWidgetIds')).controls; let entityIndex = index">
          <mat-accordion togglePosition="before" displayMode="flat">
            <mat-expansion-panel class="sub-panel mb-2" togglePosition="before" displayMode="flat">
          <mat-expansion-panel-header>
            <mat-panel-title>{{ getSelectedEntityName(entitywidgetMapping)}}</mat-panel-title>
          </mat-expansion-panel-header>
          <div [formGroupName]="entityIndex" class="gap-2 align-items-center">
            <mat-form-field class="w-100 mt-3 rounded-0" appearance="outline">
              <mat-label>Widgets</mat-label>
              <mat-select formControlName="basedWidgets" placeholder="select widgets" multiple  searchable [isObjectsList]="true" [displayKey]="'widgetLabel'" (selectionChange)="addItemsInbasedWidgetControlMappingArray($event,entityIndex,entitywidgetMapping)">
                <mat-option *ngFor="let widget of getEntityRelatedWidgets(entitywidgetMapping,entityIndex)" [value]="widget.widgetId" >{{widget.widgetLabel}}</mat-option>
              </mat-select>
            </mat-form-field>

            <div formArrayName="basedWidgetControlMapping">
              <ng-container *ngFor="let entitywidget of $any(entitywidgetMapping.get('basedWidgetControlMapping')).controls; let j = index">
                <div [formGroupName]="j" class="gap-2 align-items-center">
                <mat-form-field class="w-100 mt-3 rounded-0" appearance="outline">
                  <mat-label>{{ entitiesWidgetsMappingObj[entitywidgetMapping.value.entityId][entitywidget.value.widgetId]?.widgetLabel ?? 'widget'}}</mat-label>
                  <mat-select formControlName="dependentValue"   searchable [isObjectsList]="true" [displayKey]="'widgetLabel'">
                    <mat-option *ngFor="let widget of listOfWidgetsOfEntity" [value]="widget.widgetId" >{{widget.widgetLabel}}</mat-option>
                  </mat-select>
                </mat-form-field>
                </div>
              </ng-container>
          </div>
            </div>
        </mat-expansion-panel>
        </mat-accordion>
          </ng-container>
      </div>
    </div>
  </ng-template>
  <ng-template #filterTypeManual let-group="group">
    <div [formGroup]="group">
      <mat-form-field class="w-100 mt-3 rounded-0" appearance="outline">
        <mat-label>Filter type</mat-label>
        <mat-select formControlName="filterType"   searchable [isObjectsList]="true" [displayKey]="'entity_name'">
          <mat-option *ngFor="let type of [dropdownDataSourceFilterTypes.manual]" [value]="type" >{{type | titlecase}}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="w-100 mt-3 rounded-0" appearance="outline">
        <mat-label>Filter string</mat-label>
        <input type="text" matInput formControlName="ref">
      </mat-form-field>
      <mat-form-field class="w-100 mt-3 rounded-0" appearance="outline">
        <mat-label>Depentend Field</mat-label>
        <mat-select formControlName="dependentValue"   searchable [isObjectsList]="true" [displayKey]="'widgetLabel'">
          <mat-option *ngFor="let widget of listOfWidgetsOfEntity" [value]="widget.widgetId" >{{widget.widgetLabel}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </ng-template>